(function () {
  var STORE = 'al-futtaim-watches-jewellery';
  var COLOR_OPTION = /color|colour|لون|dial/i;
  var SIZE_OPTION = /size|مقاس/i;
  var page = readJson('exponea-page') || {};
  var signupCustomer = readJson('exponea-customer');
  if (signupCustomer && signupCustomer.email) page.customer = Object.assign({}, page.customer || {}, signupCustomer);
  var state = {
    cart: page.cart || null,
    catalog: {},
    addedDetails: {},
    pending: null,
    meta: null,
    pendingCart: null,
    cartRequests: 0,
    cartSignature: '',
    cartTrackedAt: 0,
    cartTrackKey: '',
    cartFetching: false,
    cartFetchQueued: false,
    cartDirty: false,
    wishlistCartMoveUntil: 0,
    timer: 0,
    recoTimers: {},
    recoSent: {},
    lastSearch: '',
    categoryKey: '',
    viewedVariant: '',
    loginTracked: false,
    signupTracked: false,
    signupTimer: 0
  };

  window.cartBloom_requestStarted = function () {};
  window.cartBloom_requestComplete = function () {};
  window.exponea_wishlist = trackWishlistEvent;

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function defined(props) {
    var out = {};
    Object.keys(props || {}).forEach(function (key) {
      var value = props[key];
      if (value == null || value === '') return;
      if (Array.isArray(value) && !value.length) return;
      out[key] = value;
    });
    return out;
  }

  function asList(value) {
    if (Array.isArray(value)) {
      return value.map(function (item) { return String(item); }).filter(function (item) { return item !== ''; });
    }
    if (value == null || value === '') return [];
    var text = String(value).trim();
    if (!text) return [];
    if (text.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(text);
        if (Array.isArray(parsed)) return asList(parsed);
      } catch (error) {}
    }
    if (text.indexOf(',') !== -1 && text.indexOf(' > ') === -1) {
      return text.split(',').map(function (part) { return part.trim(); }).filter(Boolean);
    }
    return [text];
  }

  function withLists(props, keys) {
    keys.forEach(function (key) {
      if (!props || props[key] == null || props[key] === '') return;
      props[key] = asList(props[key]);
    });
    return props;
  }

  function tagList(value) {
    var items = [];
    function add(entry) {
      if (entry == null || entry === '') return;
      if (Array.isArray(entry)) {
        entry.forEach(add);
        return;
      }
      var text = String(entry).trim();
      if (!text || text === 'null' || text === 'undefined') return;
      if (text.charAt(0) === '[' && text.charAt(text.length - 1) === ']') {
        try {
          var parsed = JSON.parse(text);
          if (Array.isArray(parsed)) {
            parsed.forEach(add);
            return;
          }
        } catch (error) {}
      }
      text.split(',').forEach(function (part) {
        var tag = part.trim();
        if (tag) items.push(tag);
      });
    }
    add(value);
    return items;
  }

  function arrayValue(value) {
    var items = tagList(value);
    if (!items.length) return '';
    return '[' + items.map(function (item) {
      return JSON.stringify(String(item));
    }).join(', ') + ']';
  }

  function idList(values) {
    var items = (values || []).map(function (item) { return item == null ? '' : String(item); });
    if (!items.some(function (item) { return item !== ''; })) return '';
    return '[' + items.map(function (item) { return JSON.stringify(item); }).join(', ') + ']';
  }

  function tagsValue(value) {
    return arrayValue(value);
  }

  function track(name, props) {
    if (!window.exponea || typeof window.exponea.track !== 'function') return;
    window.exponea.track(name, defined(Object.assign({
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: page.source_type || 'web',
      domain: page.domain || '',
      language: page.language || '',
      locale: page.locale || '',
      local_currency: currency(),
      location: window.location.href,
      os: os()
    }, props || {})));
  }

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || page.currency || '';
  }

  function money(cents) {
    var value = Number(cents);
    if (!value) return 0;
    return Math.round(value) / 100;
  }

  function trackSearch(term) {
    var query = String(term || '').replace(/\s+/g, ' ').trim();
    if (!query || state.lastSearch === query) return;
    state.lastSearch = query;
    track('search', {
      search_term: query,
      device: device(),
      location: 'search'
    });
  }

  function searchQuery() {
    var params = new URLSearchParams(window.location.search);
    var input = document.querySelector('.ais-search-box--input, form[role="search"] [name="q"]');
    return (input && input.value) || params.get('q') || params.get('search') || (page.search && page.search.terms) || '';
  }

  function watchSearch() {
    if (page.page_type !== 'search') return;
    trackSearch(searchQuery());
    var timer = 0;
    function schedule() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        trackSearch(searchQuery());
      }, 600);
    }
    window.addEventListener('popstate', schedule);
    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el || !el.closest) return;
      if (el.name === 'q' || el.closest('.ais-search-box-container')) schedule();
    }, true);
  }

  function watchHeaderSearch() {
    var form = document.getElementById('customer_search');
    if (!form || form.dataset.exponeaSearch) return;
    form.dataset.exponeaSearch = '1';

    function queryFrom(target) {
      var input = (target && target.matches && target.matches('input')) ? target : form.querySelector('input[name="q"], input[type="search"]');
      return input ? input.value : '';
    }

    form.addEventListener('submit', function () {
      trackSearch(queryFrom());
    }, true);

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target;
      if (!input || !form.contains(input)) return;
      if (input.name !== 'q' && input.type !== 'search') return;
      trackSearch(queryFrom(input));
    }, true);
  }

  function pageType() {
    return { index: 'homepage', product: 'pdp', collection: 'plp', search: 'search', cart: 'cart' }[page.page_type] || page.page_type || '';
  }

  function buttonType() {
    return { index: 'Recommendation', product: 'Product detail', collection: 'PLP', search: 'Search', cart: 'Cart' }[page.page_type] || 'Other';
  }

  function cartSurface() {
    return page.page_type === 'cart' ? 'Cart' : 'Ajax Cart';
  }

  function labelOf(el) {
    if (!el) return '';
    var span = el.querySelector('span');
    return ((span && span.textContent) || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function categoryProps() {
    var collection = page.collection || {};
    var level1 = heliumText(collection.category_level_1);
    var level2 = heliumText(collection.category_level_2);
    var level3 = heliumText(collection.category_level_3);
    var levels = [level1, level2, level3].filter(Boolean);
    if (!levels.length && collection.title) levels = [heliumText(collection.title)].filter(Boolean);
    if (!levels.length) return {};
    return defined({
      category_name: levels[1] || levels[0],
      category_id: categoryIdFromLevels(levels) || (collection.handle ? String(collection.handle) : ''),
      category_level_1: levels[0] || '',
      category_level_2: levels[1] || '',
      category_level_3: levels[2] || '',
      categories_path: levels.join(' > '),
      categories_ids: levels.map(categorySlug)
    });
  }

  function heliumText(value) {
    if (value == null) return '';
    if (Array.isArray(value)) return heliumText(value[0]);
    if (typeof value === 'object') {
      if (value.value != null) return heliumText(value.value);
      if (value.label != null) return heliumText(value.label);
      if (value.title != null) return heliumText(value.title);
      if (value.name != null) return heliumText(value.name);
      var keys = Object.keys(value);
      if (keys.length === 1) return heliumText(value[keys[0]]);
      return '';
    }
    var text = String(value).trim();
    if (!text || text === 'null' || text === 'undefined') return '';
    if (text.charAt(0) === '[') {
      try {
        return heliumText(JSON.parse(text));
      } catch (error) {
        text = text.replace(/[\[\]"]/g, '').split(',')[0].trim();
      }
    }
    return text;
  }

  function categorySlug(level) {
    return String(level || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function prefixCategoryIds(value) {
    if (value == null || value === '') return value;
    var items = tagList(value);
    if (!items.length) return value;
    var prefixed = items.map(function (item) {
      var text = String(item).trim();
      if (!text) return '';
      return text.indexOf('cat_') === 0 ? text : 'cat_' + text;
    }).filter(Boolean);
    if (!prefixed.length) return value;
    return typeof value === 'string' ? arrayValue(prefixed) : prefixed;
  }

  function withCategoryIdPrefix(props) {
    if (!props || props.categories_ids == null || props.categories_ids === '') return props;
    return Object.assign({}, props, { categories_ids: prefixCategoryIds(props.categories_ids) });
  }

  function categoryIdFromLevels(levels) {
    if (!levels.length) return '';
    if (levels.length === 1) return categorySlug(levels[0]);
    var parent = categorySlug(levels[levels.length - 2]).replace(/-?watches$/, '');
    var leaf = categorySlug(levels[levels.length - 1]);
    if (!parent || leaf === parent || leaf.indexOf(parent + '-') === 0) return leaf;
    return parent + '-' + leaf;
  }

  function categoryFromHelium(helium) {
    if (!helium) return {};
    var level1 = heliumText(helium.h_category) || heliumText(helium.category_level_1);
    var level2 = heliumText(helium.h_subcategory) || heliumText(helium.category_level_2);
    var level3 = heliumText(helium.h_subcategory_type) || heliumText(helium.category_level_3);
    var levels = [level1, level2, level3].filter(Boolean);
    if (!levels.length) return {};
    return defined({
      category_level_1: level1,
      category_level_2: level2,
      category_level_3: level3,
      category_name: heliumText(helium.category_name) || level2 || level1,
      category_id: categoryIdFromLevels(levels),
      categories_path: levels.join(' > '),
      categories_ids: levels.map(categorySlug),
      color: heliumText(helium.h_colour_primary_value) || heliumText(helium.color)
    });
  }

  function categoryPath(value) {
    if (value == null || value === '') return '';
    if (Array.isArray(value)) {
      var parts = value.map(heliumText).filter(Boolean);
      if (!parts.length) return '';
      if (parts.length === 1 && parts[0].indexOf(' > ') !== -1) return parts[0];
      return parts.join(' > ');
    }
    var text = heliumText(value);
    if (!text) return '';
    if (text.charAt(0) === '[') {
      var items = tagList(text);
      if (!items.length) return '';
      if (items.length === 1 && items[0].indexOf(' > ') !== -1) return items[0];
      return items.join(' > ');
    }
    return text;
  }

  function pathFromLevels(source) {
    if (!source) return '';
    return [source.category_level_1, source.category_level_2, source.category_level_3].map(heliumText).filter(Boolean).join(' > ');
  }

  function bestCategoryPath(current, candidates) {
    var best = categoryPath(current);
    var bestScore = best ? best.split(/\s*>\s*/).filter(Boolean).length : 0;
    (candidates || []).forEach(function (candidate) {
      var path = categoryPath(candidate) || pathFromLevels(candidate);
      var score = path ? path.split(/\s*>\s*/).filter(Boolean).length : 0;
      if (score > bestScore) {
        best = path;
        bestScore = score;
      }
    });
    return best;
  }

  function ensureCategoryPath(line, extra) {
    if (!line) return;
    var path = bestCategoryPath(line.categories_path, [line].concat(extra || []));
    var fromLevels = pathFromLevels(line);
    if ((fromLevels ? fromLevels.split(/\s*>\s*/).filter(Boolean).length : 0) > (path ? path.split(/\s*>\s*/).filter(Boolean).length : 0)) {
      path = fromLevels;
    }
    if (path) line.categories_path = path;
  }

  function categoryFields() {
    var fields = {};
    Array.prototype.forEach.call(arguments, function (source) {
      var next = categoryFromHelium(source);
      Object.keys(next).forEach(function (key) {
        if (!fields[key] || (Array.isArray(fields[key]) && !fields[key].length)) fields[key] = next[key];
      });
    });
    return Object.keys(fields).length ? fields : categoryProps();
  }

  function categoryFromProduct(product) {
    return categoryFields(product && product.categories);
  }

  function optionValue(product, variant, pattern) {
    var names = product.options || [];
    for (var i = 0; i < names.length; i += 1) {
      var option = names[i];
      var name = option && typeof option === 'object' ? option.name : option;
      if (pattern.test(String(name || ''))) return variant['option' + (i + 1)] || (option && option.value) || '';
    }
    return '';
  }

  function sizeFromOptions(options) {
    var list = options || [];
    for (var i = 0; i < list.length; i += 1) {
      var option = list[i];
      if (!option) continue;
      var name = typeof option === 'string' ? option : (option.name || '');
      var value = typeof option === 'string' ? '' : (option.value || '');
      if (SIZE_OPTION.test(String(name)) && value) return value;
    }
    return '';
  }

  function syncPrices(fields, selling, original) {
    var sale = Number(selling) || 0;
    var list = Number(original) || 0;
    if (list && sale && list < sale) {
      var swap = list;
      list = sale;
      sale = swap;
    }
    if (!sale) sale = list;
    if (!list || list < sale) list = sale;
    fields.price = sale;
    fields.price_local_currency = sale;
    fields.original_price = list;
    fields.original_price_local_currency = list;
    fields.discount_value = list > sale ? +(list - sale).toFixed(2) : 0;
    fields.discount_percentage = list > sale ? Math.round((1 - sale / list) * 100) : 0;
    return fields;
  }

  function priceFields(priceCents, compareCents) {
    return syncPrices({}, money(priceCents), money(compareCents));
  }

  function taxFields(total) {
    var tax = Number(page.tax_percentage);
    if (!tax || !total) return {};
    var taxValue = +((total * tax) / 100).toFixed(2);
    return {
      tax_percentage: tax,
      tax_value: taxValue,
      total_price_without_tax: +(total - taxValue).toFixed(2)
    };
  }

  function boolFlag(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function propText(props, key) {
    if (!props) return '';
    var value = props[key];
    return value == null ? '' : String(value).trim();
  }

  // Metafield capability (custom.engraving / custom.gift_wrapping) → list item_* flags only.
  function metafieldCapability(source) {
    source = source || {};
    var bloom = source.bloom && typeof source.bloom === 'object' ? source.bloom : null;
    function pickMeta(primary, legacy) {
      if (source[primary] != null && source[primary] !== '') return source[primary];
      if (bloom && bloom[primary] != null && bloom[primary] !== '') return bloom[primary];
      // New bloom/item format stores metafield on item_*; root engraving is selection.
      if (source.item_engraving_flag != null || source.item_gift_wrapping_flag != null) return false;
      if (bloom && (bloom.item_engraving_flag != null || bloom.item_gift_wrapping_flag != null)) return false;
      if (source[legacy] != null && source[legacy] !== '') return source[legacy];
      if (bloom && bloom[legacy] != null && bloom[legacy] !== '') return bloom[legacy];
      return false;
    }
    return {
      item_engraving_flag: boolFlag(pickMeta('item_engraving_flag', 'engraving')),
      item_gift_wrapping_flag: boolFlag(pickMeta('item_gift_wrapping_flag', 'gift_wrapping'))
    };
  }

  // Customer selection from cart line properties (confirmed engraving / gift wrap).
  function lineSelectionFlags(item) {
    var props = (item && item.properties) || item || {};
    if (props._type === 'engraving-fee' || props['_Gift Wrap Item'] === 'true' || props['_Gift Wrap Item'] === true) {
      return { engraving: false, gift_wrapping: false };
    }
    return {
      engraving: !!(propText(props, '_Engraving Id') || propText(props, 'Engraving Line 1')),
      gift_wrapping: !!(
        propText(props, '_Gift Wrap Id') ||
        propText(props, 'Gift Wrap Paper') ||
        propText(props, 'Gift Wrap To') ||
        propText(props, 'Gift Wrap Message')
      )
    };
  }

  // Customer selection from PDP gift-option UI after save (summary + remove control).
  function pageSelectionFlags(scope) {
    scope = scope || document;
    var engraving = false;
    var gift = false;
    try {
      var engravingSummary = scope.querySelector('[data-engraving-summary]');
      var engravingRemove = scope.querySelector('[data-engraving-remove]');
      if (engravingRemove && engravingSummary && !engravingSummary.hidden) {
        engraving = true;
      } else {
        var engravingId = scope.querySelector('[data-engraving-hidden-id]');
        var engravingLine = scope.querySelector('[data-engraving-hidden-line="1"]');
        if (engravingId && !engravingId.disabled && String(engravingId.value || '').trim()) engraving = true;
        else if (engravingLine && !engravingLine.disabled && String(engravingLine.value || '').trim()) engraving = true;
      }
      // Cart page: saved gift wrap shows data-cart-giftwrap-remove-trigger on the summary action.
      if (scope.querySelector('[data-cart-giftwrap-remove-trigger]')) {
        gift = true;
      } else {
        var giftSummary = scope.querySelector('[data-giftwrap-summary]');
        var giftRemove = scope.querySelector('[data-giftwrap-remove]');
        if (giftRemove && giftSummary && !giftSummary.hidden) {
          gift = true;
        } else {
          var giftId = scope.querySelector('[data-giftwrap-hidden-id]');
          if (giftId && !giftId.disabled && String(giftId.value || '').trim()) gift = true;
        }
      }
    } catch (error) {}
    return { engraving: engraving, gift_wrapping: gift };
  }

  // Root engraving / gift_wrapping = customer selection (default false).
  // Never map product metafields into these keys.
  function selectionFlags(options) {
    options = options || {};
    var selected = { engraving: false, gift_wrapping: false };
    if (options.item) {
      var fromLine = lineSelectionFlags(options.item);
      if (fromLine.engraving) selected.engraving = true;
      if (fromLine.gift_wrapping) selected.gift_wrapping = true;
    }
    if (options.usePage) {
      var fromPage = pageSelectionFlags(options.scope);
      if (fromPage.engraving) selected.engraving = true;
      if (fromPage.gift_wrapping) selected.gift_wrapping = true;
    }
    if (options.engraving != null) selected.engraving = !!options.engraving;
    if (options.gift_wrapping != null) selected.gift_wrapping = !!options.gift_wrapping;
    return selected;
  }

  function serviceFlags(source, options) {
    options = options || {};
    if (options.selection === false) {
      return { engraving: false, gift_wrapping: false };
    }
    if (source && source.properties) {
      return lineSelectionFlags(source);
    }
    if (options.usePage) {
      return pageSelectionFlags(options.scope);
    }
    // Default: selection false (view_item / product JSON metafield must not flip these).
    return { engraving: false, gift_wrapping: false };
  }

  // List entries (product_list, variant_list, sku_list, shopify_*_list) mirror
  // customer selection: item_engraving_flag === engraving, item_gift_wrapping_flag === gift_wrapping.
  function listServiceFlags(source) {
    source = source || {};
    var selected = lineSelectionFlags(source);
    if (source.engraving != null) selected.engraving = !!source.engraving;
    if (source.gift_wrapping != null) selected.gift_wrapping = !!source.gift_wrapping;
    var bloom = source.bloom && typeof source.bloom === 'object' ? source.bloom : null;
    // New-format bloom stamps selection on engraving/gift_wrapping alongside item_* keys.
    if (bloom && (bloom.item_engraving_flag != null || bloom.item_gift_wrapping_flag != null)) {
      if (boolFlag(bloom.engraving)) selected.engraving = true;
      if (boolFlag(bloom.gift_wrapping)) selected.gift_wrapping = true;
    }
    return {
      item_engraving_flag: !!selected.engraving,
      item_gift_wrapping_flag: !!selected.gift_wrapping
    };
  }

  function stockLevel(source) {
    if (!source) return null;
    var value = source.stock_level;
    if (value == null || value === '') value = source.inventory;
    if (value == null || value === '') return null;
    var number = Number(value);
    return isNaN(number) ? null : number;
  }

  // Same value view_item sends: Liquid variant.inventory_quantity on .exponea-product.
  function pageVariantInventory(variantId, productId) {
    var nodes = document.querySelectorAll('.exponea-product');
    var index;
    for (index = 0; index < nodes.length; index += 1) {
      var product = null;
      try { product = JSON.parse(nodes[index].textContent); } catch (error) { continue; }
      if (!product || !product.variants) continue;
      if (productId && String(product.id) !== String(productId)) continue;
      var variant = variantId
        ? product.variants.find(function (entry) { return String(entry.id) === String(variantId); })
        : null;
      if (!variant && page.page_type === 'product') {
        var selected = productOnPage();
        if (selected && String(selected.product.id) === String(product.id)) variant = selected.variant;
      }
      var stock = stockLevel(variant);
      if (stock != null) return stock;
    }
    return null;
  }

  function assignViewItemStock(variantId, productId, handle, useViewedVariant) {
    if (useViewedVariant && page.page_type === 'product') {
      var viewed = productOnPage();
      if (viewed && (!productId || String(viewed.product.id) === String(productId))) {
        var viewedStock = stockLevel(viewed.variant);
        if (viewedStock != null) return Promise.resolve(viewedStock);
      }
    }
    var exact = pageVariantInventory(variantId, productId);
    if (exact != null) return Promise.resolve(exact);
    if (!handle) return Promise.resolve(null);
    return loadCatalogProduct(handle).then(function (catalog) {
      var variants = (catalog && catalog.variants) || [];
      var variant = variants.find(function (entry) { return String(entry.id) === String(variantId); });
      if (!variant && variants.length === 1) variant = variants[0];
      return stockLevel(variant);
    }).catch(function () { return null; });
  }

  function withStock(props) {
    if (!props) return props;
    var stock = stockLevel(props);
    var index;
    for (index = 1; stock == null && index < arguments.length; index += 1) {
      stock = stockLevel(arguments[index]);
    }
    props.stock_level = stock == null ? 0 : stock;
    return props;
  }

  function applyButtonStock(variant, button) {
    if (!variant || stockLevel(variant) != null || !button || !button.getAttribute) return;
    var listed = button.getAttribute('data-inventory');
    if (listed == null || listed === '') return;
    var number = Number(listed);
    if (!isNaN(number)) variant.inventory = number;
  }

  function linePayload(product, variant) {
    var meta = metafieldCapability(product);
    var fields = {
      shopify_parent_id: String(product.id || ''),
      shopify_variant_id: String(variant.id || ''),
      title: product.title,
      brand: product.vendor || '',
      product_type: product.type || '',
      color: product.color || optionValue(product, variant, COLOR_OPTION),
      size: optionValue(product, variant, SIZE_OPTION) || product.size || '',
      // Selection defaults false; cart/wishlist emitters set true after save + commerce action.
      engraving: false,
      gift_wrapping: false,
      // Persist metafield capability on bloom for cart/checkout list flags.
      item_engraving_flag: meta.item_engraving_flag,
      item_gift_wrapping_flag: meta.item_gift_wrapping_flag
    };
    if (variant.barcode) fields.product_id = String(variant.barcode);
    if (variant.sku) {
      fields.variant_id = String(variant.sku);
      fields.sku_id = String(variant.sku);
    }
    var tags = tagList(product.tags);
    if (tags.length) fields.tags = tags;
    var stock = stockLevel(variant);
    if (stock != null) fields.stock_level = stock;
    return Object.assign(fields, priceFields(variant.price, variant.compare_at_price), categoryFromProduct(product));
  }

  // Canonical commerce IDs for Exponea product events:
  // product_id = UPC/barcode, variant_id/sku_id = SKU,
  // shopify_parent_id = Shopify product id, shopify_variant_id = Shopify variant id.
  function productIdentity(product, variant) {
    product = product || {};
    variant = variant || {};
    var barcode = variant.barcode != null && variant.barcode !== '' ? String(variant.barcode) : '';
    var sku = variant.sku != null && variant.sku !== '' ? String(variant.sku) : '';
    if ((!barcode || !sku) && product.id != null && variant.id != null) {
      var heart = document.querySelector(
        '#mswishlistbutton[data-product="' + String(product.id) + '"], .mswishlistbutton[data-product="' + String(product.id) + '"]'
      );
      if (heart) {
        var heartVariant = heart.getAttribute('data-variant') || heart.getAttribute('data-variant-id') || '';
        if (!heartVariant || String(heartVariant) === String(variant.id)) {
          if (!barcode) barcode = heart.getAttribute('data-barcode') || '';
          if (!sku) sku = heart.getAttribute('data-sku') || '';
        }
      }
    }
    return defined({
      product_id: barcode,
      variant_id: sku,
      sku_id: sku,
      shopify_parent_id: product.id != null && product.id !== '' ? String(product.id) : '',
      shopify_variant_id: variant.id != null && variant.id !== '' ? String(variant.id) : ''
    });
  }

  function findProductVariant(product, variantId) {
    if (!product) return null;
    var variants = product.variants || [];
    if (!variants.length) return null;
    var id = variantId != null && variantId !== '' ? String(variantId) : '';
    if (id) {
      var match = variants.find(function (item) { return String(item.id) === id; });
      if (match) return match;
    }
    return variants[0];
  }

  function productFromForm(form) {
    var dataEl = form.querySelector('.exponea-product');
    if (!dataEl) return null;
    try {
      var product = JSON.parse(dataEl.textContent);
    } catch (error) {
      return null;
    }
    if (!product) return null;
    var idInput = form.querySelector('[name="id"]') || form.querySelector('.product-variant-id');
    var variant = findProductVariant(product, idInput && idInput.value);
    if (!variant) return null;
    return { product: product, variant: variant };
  }

  function writeLineInput(form, product, variant) {
    var input = form.querySelector('.exponea-line-json');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_bloomreach_product_json]';
      input.className = 'exponea-line-json';
      form.appendChild(input);
    }
    var payload = linePayload(product, variant);
    // Stamp selection at ATC time so bloom carries engraving:true after a saved drawer.
    Object.assign(payload, selectionFlags({ usePage: true, scope: form || document }));
    input.value = JSON.stringify(payload);
  }

  function parseBloom(value) {
    if (!value) return null;
    if (typeof value === 'object') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function isChildProps(props) {
    if (!props) return false;
    return props._type === 'engraving-fee' || props['_Gift Wrap Item'] === 'true' || props['_Gift Wrap Item'] === true;
  }

  function rememberItem(item) {
    if (!item || item.id == null) return;
    var current = state.catalog[item.id] || {};
    var categories = categoryFromHelium(item.categories || item.bloom);
    state.catalog[item.id] = {
      barcode: item.barcode || current.barcode || '',
      product_type: item.product_type || current.product_type || '',
      tags: (item.tags && item.tags.length) ? item.tags : current.tags,
      color: item.color || current.color || '',
      size: item.size || current.size || '',
      categories: categories.category_level_1 ? categories : current.categories,
      original_price: item.original_price || current.original_price || 0,
      inventory: stockLevel(item) != null ? stockLevel(item) : (stockLevel(item.bloom) != null ? stockLevel(item.bloom) : (current.inventory != null ? current.inventory : null))
    };
  }

  function applyCatalog(item) {
    var extra = state.catalog[item.id];
    if (!extra) return item;
    if (!item.barcode && extra.barcode) item.barcode = extra.barcode;
    if (!item.product_type && extra.product_type) item.product_type = extra.product_type;
    if ((!item.tags || !item.tags.length) && extra.tags) item.tags = extra.tags;
    if (!item.color && extra.color) item.color = extra.color;
    if (!item.size && extra.size) item.size = extra.size;
    if (!categoryFromHelium(item.categories).category_level_1 && extra.categories) item.categories = extra.categories;
    if (!item.original_price && extra.original_price) item.original_price = extra.original_price;
    if (stockLevel(item) == null && extra.inventory != null) item.inventory = extra.inventory;
    return item;
  }

  function normalizeCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return {
      item_count: cart.item_count || 0,
      total_price: cart.total_price || 0,
      currency: cart.currency || page.currency || '',
      items: cart.items.map(function (item) {
        var properties = item.properties || {};
        var bloom = parseBloom(item.bloom || properties._bloomreach_product_json) || {};
        var options = item.options_with_values || [];
        var hasMetaKeys = item.item_engraving_flag != null || item.item_gift_wrapping_flag != null ||
          bloom.item_engraving_flag != null || bloom.item_gift_wrapping_flag != null;
        var meta = hasMetaKeys
          ? {
              item_engraving_flag: boolFlag(
                item.item_engraving_flag != null ? item.item_engraving_flag : bloom.item_engraving_flag
              ),
              item_gift_wrapping_flag: boolFlag(
                item.item_gift_wrapping_flag != null ? item.item_gift_wrapping_flag : bloom.item_gift_wrapping_flag
              )
            }
          : {
              // Legacy: engraving on item/bloom meant metafield capability.
              item_engraving_flag: boolFlag(item.engraving != null ? item.engraving : bloom.engraving),
              item_gift_wrapping_flag: boolFlag(item.gift_wrapping != null ? item.gift_wrapping : bloom.gift_wrapping)
            };
        var selected = lineSelectionFlags({ properties: properties });
        // New bloom stamps selection on engraving alongside item_* metafield keys.
        if (hasMetaKeys) {
          if (boolFlag(bloom.engraving)) selected.engraving = true;
          if (boolFlag(bloom.gift_wrapping)) selected.gift_wrapping = true;
        }
        bloom.item_engraving_flag = meta.item_engraving_flag;
        bloom.item_gift_wrapping_flag = meta.item_gift_wrapping_flag;
        bloom.engraving = selected.engraving;
        bloom.gift_wrapping = selected.gift_wrapping;
        var mapped = {
          id: item.variant_id || item.id,
          key: item.key || '',
          product_id: item.product_id,
          sku: item.sku || '',
          barcode: item.barcode || '',
          quantity: item.quantity || 0,
          price: item.final_price || item.price || 0,
          original_price: item.original_price || 0,
          line_price: item.final_line_price || item.line_price || 0,
          vendor: item.vendor || '',
          title: item.title || '',
          product_title: item.product_title || item.title || '',
          handle: item.handle || '',
          product_type: item.product_type || '',
          tags: item.tags || [],
          color: item.color || '',
          size: bloom.size || item.size || sizeFromOptions(options),
          engraving: selected.engraving,
          gift_wrapping: selected.gift_wrapping,
          item_engraving_flag: meta.item_engraving_flag,
          item_gift_wrapping_flag: meta.item_gift_wrapping_flag,
          options_with_values: options,
          categories: item.categories || null,
          properties: properties,
          bloom: bloom
        };
        rememberItem(mapped);
        return applyCatalog(mapped);
      })
    };
  }

  function isFullCart(data) {
    return data && Array.isArray(data.items) && typeof data.item_count === 'number';
  }

  function isChildItem(data) {
    if (!data) return false;
    if (data.item_count == null && !Array.isArray(data.items) && isChildProps(data.properties)) return true;
    if (Array.isArray(data.items) && data.items.length && data.item_count == null) {
      return data.items.every(function (item) { return isChildProps(item.properties); });
    }
    return false;
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    return (input && input.url) || '';
  }

  function quantityFromInit(init) {
    var body = init && init.body;
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json.updates) {
          var values = Object.keys(json.updates).map(function (key) {
            return Number(json.updates[key]);
          });
          if (values.length && values.every(function (value) { return value === 0; })) return 0;
          return values[0];
        }
        if (json.quantity != null) return Number(json.quantity);
      } catch (error) {}
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var quantity = body.get('quantity');
      if (quantity != null && quantity !== '') return Number(quantity);
    }
    return null;
  }

  function requestFields(init) {
    var body = init && init.body;
    if (!body) return {};
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json && typeof json === 'object') return json;
      } catch (error) {}
      return readRequestBody(body);
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return {
        id: body.get('id'),
        line: body.get('line'),
        quantity: body.get('quantity'),
        updates: body.get('updates'),
        note: body.get('note'),
        discount: body.get('discount')
      };
    }
    return {};
  }

  function explicitCartEdit(init) {
    var fields = requestFields(init);
    return fields.note != null || (fields.discount != null && fields.discount !== '');
  }

  function actionFromRequest(url, init) {
    var pending = state.pending || {};
    state.pending = null;
    var edited = explicitCartEdit(init);
    if (/\/cart\/add(\.js)?/.test(url)) {
      return {
        action: 'add',
        button: pending.button || null,
        button_type: pending.button_type || buttonType(),
        button_copy: pending.button_copy || 'Add to cart',
        edited: false
      };
    }
    var quantity = quantityFromInit(init);
    var removing = quantity === 0 || pending.action === 'remove';
    return {
      action: removing ? 'remove' : 'update',
      button_type: pending.button_type || cartSurface(),
      button_copy: pending.button_copy || (removing ? 'remove' : 'update'),
      edited: edited
    };
  }

  function changedItem(previous, next, action) {
    var prevItems = (previous && previous.items) || [];
    var nextItems = (next && next.items) || [];
    if (action === 'remove') {
      return prevItems.find(function (item) {
        return !isChildProps(item.properties) && !nextItems.some(function (nextItem) { return nextItem.key && nextItem.key === item.key; });
      }) || null;
    }
    var added = nextItems.find(function (item) {
      return !isChildProps(item.properties) && !prevItems.some(function (prevItem) { return prevItem.key && prevItem.key === item.key; });
    });
    if (added) return added;
    return nextItems.find(function (item) {
      var prevItem = prevItems.find(function (entry) { return entry.key && entry.key === item.key; });
      return prevItem && prevItem.quantity !== item.quantity && !isChildProps(item.properties);
    }) || null;
  }

  function lineFromCartItem(item) {
    if (!item) return {};
    var bloom = item.bloom || {};
    var selling = money(item.price);
    var listed = money(item.original_price);
    var bloomSale = Number(bloom.price_local_currency || bloom.price) || 0;
    var bloomList = Number(bloom.compare_at_price || bloom.original_price) || 0;
    if (selling && bloomSale > selling * 20) bloomSale = +(bloomSale / 100).toFixed(2);
    if (selling && bloomList > selling * 20) bloomList = +(bloomList / 100).toFixed(2);
    if (!selling) selling = bloomSale;
    if (bloomList > listed) listed = bloomList;
    var fields = {
      shopify_parent_id: String(bloom.shopify_parent_id || item.product_id || ''),
      shopify_variant_id: String(bloom.shopify_variant_id || item.id || ''),
      title: bloom.title || item.product_title || item.title || '',
      brand: bloom.brand || item.vendor || '',
      product_type: bloom.product_type || item.product_type || '',
      color: bloom.color || item.color || '',
      size: bloom.size || item.size || sizeFromOptions(item.options_with_values) || ''
    };
    var catalogHit = state.catalog[String(item.id || '')] || {};
    var productId = bloom.product_id || item.barcode || catalogHit.barcode || '';
    var sku = bloom.sku_id || bloom.variant_id || item.sku;
    if (productId) fields.product_id = String(productId);
    if (!fields.product_id) {
      var parentId = String(bloom.shopify_parent_id || item.product_id || '');
      if (parentId) fields.product_id = parentId;
    }
    if (sku) {
      fields.variant_id = String(sku);
      fields.sku_id = String(sku);
    }
    var tags = tagList((bloom.tags && (bloom.tags.length || typeof bloom.tags === 'string')) ? bloom.tags : item.tags);
    if (tags.length) fields.tags = tags;
    var line = defined(Object.assign(fields, categoryFields(bloom, item.categories), syncPrices({}, selling, listed || selling)));
    if (!line.categories_path && bloom.categories_path) line.categories_path = bloom.categories_path;
    if (!line.color && bloom.color) line.color = bloom.color;
    if (!line.product_id && bloom.product_id) line.product_id = String(bloom.product_id);
    if (!line.product_id) {
      var fallbackParent = String(bloom.shopify_parent_id || item.product_id || '');
      if (fallbackParent) line.product_id = fallbackParent;
    }
    ensureCategoryPath(line, [bloom, item.categories, categoryProps()]);
    Object.assign(line, selectionFlags({ item: item }));
    return line;
  }

  function parseHeliumValue(value) {
    if (!value) return {};
    try {
      return JSON.parse(value);
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch (decodeError) {
        return {};
      }
    }
  }

  function cartSourceFromButton(button) {
    if (!button) return null;
    var card = button.closest ? button.closest('.ais-product, .card-wrapper, .card, product-info, li') : null;
    var scope = card || (button.closest ? button.parentElement : null);
    var heart = null;
    if (button.classList && (button.classList.contains('mswishlistbutton') || String(button.id || '').indexOf('mswishlistbutton') === 0)) heart = button;
    if (!heart && scope && scope.querySelector) heart = scope.querySelector('.mswishlistbutton, [id^="mswishlistbutton"]');
    if (!heart && card && card.parentElement && card.parentElement.querySelector) heart = card.parentElement.querySelector('.mswishlistbutton, [id^="mswishlistbutton"]');
    var helium = parseHeliumValue((button.getAttribute && button.getAttribute('data-helium')) || (heart && heart.getAttribute('data-helium')) || '');
    var categories = categoryFromHelium(helium);
    var level1 = categories.category_level_1 || (heart && heart.getAttribute('data-category-1')) || '';
    var level2 = categories.category_level_2 || (heart && heart.getAttribute('data-category-2')) || '';
    var level3 = categories.category_level_3 || (heart && heart.getAttribute('data-category-3')) || '';
    var levels = [level1, level2, level3].map(heliumText).filter(Boolean);
    var barcode = (card && card.dataset && card.dataset.barcode) || (heart && heart.getAttribute('data-barcode')) || (button.getAttribute && button.getAttribute('data-barcode')) || '';
    var sku = (card && card.dataset && card.dataset.sku) || (heart && heart.getAttribute('data-sku')) || (button.getAttribute && button.getAttribute('data-sku')) || '';
    var parentId = (card && card.dataset && card.dataset.id) || (heart && heart.getAttribute('data-product')) || (button.getAttribute && button.getAttribute('data-product-id')) || '';
    var variantId = (card && card.dataset && (card.dataset.variantId || card.dataset.objectid)) || (button.getAttribute && (button.getAttribute('data-object-id') || button.getAttribute('data-variant'))) || (heart && heart.getAttribute('data-variant')) || '';
    return {
      product_id: barcode ? String(barcode) : '',
      variant_id: sku ? String(sku) : '',
      sku_id: sku ? String(sku) : '',
      shopify_parent_id: parentId ? String(parentId) : '',
      shopify_variant_id: variantId ? String(variantId) : '',
      handle: (card && card.dataset && card.dataset.handle) || (heart && heart.getAttribute('data-handle')) || (button.getAttribute && button.getAttribute('data-handle')) || '',
      price: Number((button.getAttribute && button.getAttribute('data-price')) || (heart && heart.getAttribute('data-price')) || 0) || 0,
      original_price: Number((button.getAttribute && button.getAttribute('data-compare-at-price')) || (heart && heart.getAttribute('data-compare-at-price')) || 0) || 0,
      color: categories.color || heliumText(heart && heart.getAttribute('data-color')) || heliumText(button.getAttribute && button.getAttribute('data-color')) || '',
      tags: tagList((heart && heart.getAttribute('data-tags')) || (button.getAttribute && button.getAttribute('data-tags')) || ''),
      category_level_1: level1,
      category_level_2: level2,
      category_level_3: level3,
      categories_path: levels.join(' > '),
      categories_ids: categories.categories_ids || '',
      stock_level: stockLevel({
        inventory: (button.getAttribute && button.getAttribute('data-inventory')) || (heart && heart.getAttribute('data-inventory')) || ''
      })
    };
  }

  function rememberAddedDetails(variantId, details) {
    var id = String(variantId || (details && details.shopify_variant_id) || '');
    if (!id || !details) return;
    var current = state.addedDetails[id] || {};
    var next = Object.assign({}, current);
    Object.keys(details).forEach(function (key) {
      var value = details[key];
      if (value == null || value === '') return;
      if (Array.isArray(value) && !value.length) return;
      next[key] = value;
    });
    state.addedDetails[id] = next;
  }

  function mergeAddedDetails(line, item) {
    var variantId = String((item && item.id) || (line && line.shopify_variant_id) || '');
    var saved = state.addedDetails[variantId];
    if (!line || !saved) return;
    if (saved.product_id && (!line.product_id || String(line.product_id) === String(line.shopify_parent_id || ''))) {
      line.product_id = String(saved.product_id);
    }
    if (!line.product_id && line.shopify_parent_id) line.product_id = String(line.shopify_parent_id);
    if (!line.color && saved.color) line.color = saved.color;
    if (!tagList(line.tags).length && tagList(saved.tags).length) line.tags = saved.tags;
    if (!line.category_level_1 && saved.category_level_1) line.category_level_1 = saved.category_level_1;
    if (!line.category_level_2 && saved.category_level_2) line.category_level_2 = saved.category_level_2;
    if (!line.category_level_3 && saved.category_level_3) line.category_level_3 = saved.category_level_3;
    if (!line.handle && saved.handle) line.handle = saved.handle;
    if (line.stock_level == null && saved.stock_level != null && saved.stock_level !== '') line.stock_level = Number(saved.stock_level);
    var savedOriginal = Number(saved.original_price) || Number(saved.compare_at_price) || 0;
    var selling = Number(line.price) || 0;
    if (savedOriginal && selling && savedOriginal > selling * 20) savedOriginal = +(savedOriginal / 100).toFixed(2);
    if (savedOriginal > (Number(line.original_price) || 0)) syncPrices(line, selling || savedOriginal, savedOriginal);
    var savedPath = categoryPath(saved.categories_path) || pathFromLevels(saved);
    if (savedPath) {
      var savedScore = savedPath.split(/\s*>\s*/).filter(Boolean).length;
      var currentScore = (categoryPath(line.categories_path) || '').split(/\s*>\s*/).filter(Boolean).length;
      if (savedScore >= currentScore) line.categories_path = savedPath;
    }
    ensureCategoryPath(line, [saved]);
  }

  function applyCatalogProductLine(line, product, variantId) {
    if (!line || !product) return;
    var variant = (product.variants || []).find(function (entry) {
      return String(entry.id) === String(variantId);
    }) || (product.variants || [])[0];
    if (variant && variant.barcode) line.product_id = String(variant.barcode);
    else if (!line.product_id && line.shopify_parent_id) line.product_id = String(line.shopify_parent_id);
    if (!line.sku_id && variant && variant.sku) {
      line.variant_id = String(variant.sku);
      line.sku_id = String(variant.sku);
    }
    if (!tagList(line.tags).length && product.tags && product.tags.length) line.tags = product.tags;
    if (!line.color && product.color) line.color = product.color;
    if (!line.color && variant) line.color = optionValue(product, variant, COLOR_OPTION);
    if (!line.brand && product.vendor) line.brand = product.vendor;
    if (!line.product_type && product.type) line.product_type = product.type;
    if (product.categories) {
      var fromProduct = categoryFromProduct(product);
      Object.keys(fromProduct).forEach(function (key) {
        if (line[key] == null || line[key] === '' || (Array.isArray(line[key]) && !line[key].length)) {
          line[key] = fromProduct[key];
        }
      });
    }
    if (variant) {
      var selling = Number(line.price) || money(variant.price);
      var compare = money(variant.compare_at_price);
      var listed = Math.max(Number(line.original_price) || 0, compare || 0, selling || 0);
      syncPrices(line, selling || listed, listed);
    }
    if (line.discount_value == null) line.discount_value = 0;
    if (line.discount_percentage == null) line.discount_percentage = 0;
  }

  function resolveCatalogProduct(handle, productId) {
    var pageProduct = productFromPage(productId, handle);
    if (pageProduct) return Promise.resolve(pageProduct);
    if (!handle) return Promise.resolve(null);
    // Prefer products.js — it is fast and reliable. HTML catalog is a non-blocking fallback.
    return loadProduct(handle).then(function (product) {
      var finished = false;
      return new Promise(function (resolve) {
        function done(value) {
          if (finished) return;
          finished = true;
          resolve(value || product || null);
        }
        loadCatalogProduct(handle).then(function (catalog) {
          if (product && catalog) {
            if (catalog.categories) product.categories = catalog.categories;
            if (catalog.color && !product.color) product.color = catalog.color;
            if (catalog.tags && catalog.tags.length && (!product.tags || !product.tags.length)) {
              product.tags = catalog.tags;
            }
            (catalog.variants || []).forEach(function (source) {
              var stock = stockLevel(source);
              if (stock == null) return;
              var match = (product.variants || []).find(function (entry) { return String(entry.id) === String(source.id); });
              if (match) match.inventory = stock;
            });
          }
          done(product || catalog || null);
        }).catch(function () {
          done(product);
        });
        window.setTimeout(function () {
          done(product);
        }, 500);
      });
    }).catch(function () {
      return loadCatalogProduct(handle).catch(function () { return null; });
    });
  }

  function writeBloomInput(form, payload) {
    if (!form || !payload) return;
    var input = form.querySelector('.exponea-line-json');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_bloomreach_product_json]';
      input.className = 'exponea-line-json';
      form.appendChild(input);
    }
    input.value = JSON.stringify(payload);
  }

  function cartLists(items) {
    var productList = [];
    var productIds = [];
    var variantList = [];
    var variantIds = [];
    var skuList = [];
    var skuIds = [];
    var parentList = [];
    var parentIds = [];
    var shopifyVariantList = [];
    var shopifyVariantIds = [];

    items.forEach(function (item) {
      if (isChildProps(item.properties)) return;
      var bloom = item.bloom || {};
      var flags = listServiceFlags(item);
      var sku = bloom.sku_id || item.sku || '';
      var productId = bloom.product_id || item.barcode || '';
      var parentId = String(bloom.shopify_parent_id || item.product_id || '');
      var variantId = String(bloom.shopify_variant_id || item.id || '');
      var quantity = item.quantity;
      if (productId) {
        productList.push(Object.assign({ product_id: String(productId), quantity: quantity }, flags));
        productIds.push(String(productId));
      }
      if (sku) {
        variantList.push(Object.assign({ variant_id: String(sku), quantity: quantity }, flags));
        variantIds.push(String(sku));
        skuList.push(Object.assign({ sku_id: String(sku), quantity: quantity }, flags));
        skuIds.push(String(sku));
      }
      if (parentId) {
        parentList.push(Object.assign({ shopify_parent_id: parentId, quantity: quantity }, flags));
        parentIds.push(parentId);
      }
      if (variantId) {
        shopifyVariantList.push(Object.assign({ shopify_variant_id: variantId, quantity: quantity }, flags));
        shopifyVariantIds.push(variantId);
      }
    });

    return defined({
      product_list: productList,
      product_ids: productIds,
      variant_list: variantList,
      variant_ids: variantIds,
      sku_list: skuList,
      sku_ids: skuIds,
      shopify_parent_id_list: parentList,
      shopify_parent_ids: parentIds,
      shopify_variant_id_list: shopifyVariantList,
      shopify_variant_ids: shopifyVariantIds
    });
  }

  function cartSignature(cart) {
    // Stable fingerprint: ignore volatile line_price and normalize item order.
    return ((cart && cart.items) || []).filter(function (item) {
      return !isChildProps(item.properties);
    }).map(function (item) {
      return String(item.id) + ':' + String(item.quantity || 0);
    }).sort().join('|') + '#' + String((cart && cart.item_count) || 0);
  }

  var cartEmitPending = null;
  var CART_EMIT_TTL = 8000;

  function cartEmitOnce(signature) {
    var now = Date.now();
    var shared = window.__afwjCartSent || (window.__afwjCartSent = {});
    var key = String(signature || '');
    if (!key) return true;
    if (shared[key] && now - shared[key] < CART_EMIT_TTL) return false;
    shared[key] = now;
    return true;
  }

  function trackCart(cart, meta) {
    meta = Object.assign({}, meta || { action: 'update' });
    var signature = cartSignature(cart);
    var now = Date.now();
    var previous = state.cart;
    var previousSignature = cartSignature(previous);
    var changed = signature !== previousSignature;

    // A new line item is an add even if a later /cart/update request labeled it "update".
    if (meta.action !== 'add' && meta.action !== 'remove') {
      var addedLine = changedItem(previous, cart, 'add');
      var isNewLine = !!(addedLine && !((previous && previous.items) || []).some(function (entry) {
        return entry.key && addedLine.key && entry.key === addedLine.key;
      }));
      if (isNewLine) {
        meta.action = 'add';
        if (!meta.button_type) meta.button_type = buttonType();
        if (!meta.button_copy) meta.button_copy = 'Add to cart';
      } else {
        var removedLine = changedItem(previous, cart, 'remove');
        if (removedLine) meta.action = 'remove';
      }
    }

    if (!changed && !meta.edited) {
      state.cart = cart;
      state.cartSignature = signature;
      return;
    }

    // Same cart snapshot already queued or recently emitted — never send a second event.
    if (signature) {
      if (cartEmitPending && cartEmitPending.signature === signature) {
        if (meta.action === 'add' && cartEmitPending.meta.action !== 'add') cartEmitPending.meta = meta;
        else if (meta.action === 'remove' && cartEmitPending.meta.action !== 'remove' && cartEmitPending.meta.action !== 'add') {
          cartEmitPending.meta = meta;
        }
        state.cart = cart;
        return;
      }
      var shared = window.__afwjCartSent || {};
      if ((shared[signature] && now - shared[signature] < CART_EMIT_TTL) ||
          (signature === state.cartSignature && now - state.cartTrackedAt < CART_EMIT_TTL)) {
        state.cart = cart;
        state.cartSignature = signature;
        return;
      }
    }

    state.cartSignature = signature;
    state.cartTrackKey = (meta.action || 'update') + '|' + signature;
    state.cartTrackedAt = now;
    state.cart = cart;
    var item = changedItem(previous, cart, meta.action);
    // Gift-wrap fee/wrap child lines are not the tracked product — promote to the parent line.
    if (item && isChildProps(item.properties)) {
      var wrapPairId = propText(item.properties, '_Gift Wrap Id');
      var parentWrap = wrapPairId
        ? (cart.items || []).find(function (entry) {
            return !isChildProps(entry.properties) && propText(entry.properties, '_Gift Wrap Id') === wrapPairId;
          })
        : null;
      if (parentWrap) item = parentWrap;
      else if (meta.action === 'remove' && previous) {
        parentWrap = wrapPairId
          ? (previous.items || []).find(function (entry) {
              return !isChildProps(entry.properties) && propText(entry.properties, '_Gift Wrap Id') === wrapPairId;
            })
          : null;
        if (parentWrap) item = parentWrap;
      }
    }
    var total = money(cart.total_price);
    var wishlistMove = meta.button_type === 'Wishlist';
    var line = withLists(lineFromCartItem(item), ['tags']);
    mergeAddedDetails(line, item);
    var variantId = String((item && item.id) || line.shopify_variant_id || '');
    var saved = state.addedDetails[variantId] || {};
    var handle = (item && item.handle) || saved.handle || '';
    var parentId = String((item && item.product_id) || line.shopify_parent_id || '');
    var needsDiscount = !(Number(line.original_price) > Number(line.price));
    var needsCatalog = !!(item && (handle || parentId) && (
      needsDiscount ||
      !line.product_id ||
      String(line.product_id) === String(line.shopify_parent_id || '') ||
      !categoryPath(line.categories_path) ||
      !line.color ||
      !tagList(line.tags).length
    ));
    var emitToken = {};
    cartEmitPending = { signature: signature, meta: meta, token: emitToken };
    var catalog = needsCatalog ? resolveCatalogProduct(handle, parentId) : Promise.resolve(null);

    function emitCartUpdate(product) {
      if (!cartEmitPending || cartEmitPending.token !== emitToken) return;
      var emitMeta = cartEmitPending.meta || meta;
      cartEmitPending = null;
      // Final gate at send-time so parallel catalog callbacks cannot double-fire.
      if (!cartEmitOnce(signature)) return;
      try {
        if (product) applyCatalogProductLine(line, product, variantId);
        if (!line.product_id && line.shopify_parent_id) line.product_id = String(line.shopify_parent_id);
        ensureCategoryPath(line, [saved, product && product.categories, categoryProps()]);
        line.tags = tagsValue(line.tags);
        if (wishlistMove) {
          if (line.categories_ids) line.categories_ids = arrayValue(line.categories_ids);
          var rate = Number(page.tax_percentage) || 0;
          if (rate && line.price) line.price_without_tax = +(Number(line.price) / (1 + rate / 100)).toFixed(2);
        }
        if (line.categories_path) line.categories_path = categoryPath(line.categories_path);
        if (line.discount_value == null) line.discount_value = 0;
        if (line.discount_percentage == null) line.discount_percentage = 0;
        // Selection: line props, cart gift-wrap summary (data-cart-giftwrap-remove-trigger), or PDP drawer.
        var selected = selectionFlags({
          item: item,
          usePage: emitMeta.action === 'add' || page.page_type === 'cart'
        });
        if (item && item.engraving) selected.engraving = true;
        if (item && item.gift_wrapping) selected.gift_wrapping = true;
        if (line.engraving) selected.engraving = true;
        if (line.gift_wrapping) selected.gift_wrapping = true;
        Object.assign(line, selected);
        // Keep list item_* flags in sync with the same selection for this emit.
        if (item) {
          item.engraving = selected.engraving;
          item.gift_wrapping = selected.gift_wrapping;
        }
        // Refresh wishlist snapshot after ATC so a later PDP wishlist remove keeps selection.
        if (selected.engraving || selected.gift_wrapping) {
          var wishParentId = String(line.shopify_parent_id || parentId || '');
          if (wishParentId && wishlistMemory[wishParentId]) {
            rememberWishlistLineSnapshot(
              Object.assign({}, (wishlistMemory[wishParentId].line || {}), {
                engraving: selected.engraving,
                gift_wrapping: selected.gift_wrapping
              }, line),
              { id: wishParentId, handle: handle || '' },
              { id: variantId }
            );
            writeWishlistItem({
              product_id: line.product_id || '',
              sku: line.sku_id || line.variant_id || '',
              shopify_parent_id: wishParentId,
              shopify_variant_id: variantId,
              engraving: selected.engraving,
              gift_wrapping: selected.gift_wrapping,
              item_engraving_flag: selected.engraving,
              item_gift_wrapping_flag: selected.gift_wrapping
            });
            saveWishlistItems();
          }
        }
        var tax = taxFields(total);
        if (wishlistMove && page.tax_percentage) {
          var taxRate = Number(page.tax_percentage) || 0;
          if (taxRate && line.price_without_tax != null) tax.tax_value = +(Number(line.price) - Number(line.price_without_tax)).toFixed(2);
          if (taxRate && total) tax.total_price_without_tax = +(total / (1 + taxRate / 100)).toFixed(2);
        }
        assignViewItemStock(variantId, parentId, handle || (product && product.handle) || '', false).then(function (stock) {
          if (stock != null) line.stock_level = stock;
          else if (stockLevel(line) == null) line.stock_level = 0;
          if (item && line.stock_level != null) {
            item.inventory = line.stock_level;
            rememberItem(item);
          }
          var cartLine = Object.assign({}, line);
          if (cartLine.categories_ids) cartLine.categories_ids = prefixCategoryIds(cartLine.categories_ids);
          track(
            'cart_update',
            Object.assign(
              {
                action: emitMeta.action || 'update',
                total_quantity: cart.item_count,
                total_price: total,
                total_price_local_currency: total,
                location: window.location.href,
                page_type: pageType(),
                button_type: emitMeta.button_type,
                button_copy: emitMeta.button_copy,
                browser: browserName(),
                device: device()
              },
              cartLists(cart.items || []),
              cartLine,
              tax
            )
          );
        }).catch(function () {});
      } catch (error) {}
    }

    catalog.then(emitCartUpdate).catch(function () {
      emitCartUpdate(null);
    });
  }

  function fetchCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(normalizeCart);
  }

  function changesCart(url, init) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) return true;
    var body = init && init.body;
    if (!body) return false;
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json.updates || json.id || json.line || json.quantity != null || json.note != null || json.attributes || json.discount) return true;
        if (json.sections || json.sections_url) return false;
      } catch (error) {}
      // Unknown string body on cart/change|update — ignore to avoid false duplicate schedules.
      return false;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if ((body.get('sections') || body.get('sections_url')) && !body.get('id') && !body.get('line') && !body.get('quantity') && !body.get('updates')) return false;
      return !!(body.get('id') || body.get('line') || body.get('quantity') || body.get('updates') || body.get('note') || body.get('discount'));
    }
    return true;
  }

  function preferCartMeta(next) {
    if (!next) return;
    if (!state.meta) {
      state.meta = next;
      return;
    }
    var current = state.meta.action;
    var incoming = next.action;
    // Keep the strongest intent from a cascade: add/remove beat generic update.
    if (incoming === 'add') {
      state.meta = next;
      return;
    }
    if (current === 'add') return;
    if (incoming === 'remove') {
      state.meta = next;
      return;
    }
    if (current === 'remove') return;
    state.meta = next;
  }

  function scheduleCart(meta) {
    if (Date.now() < state.wishlistCartMoveUntil) return;
    preferCartMeta(meta);
    state.cartDirty = true;
    window.clearTimeout(state.timer);
    // Quiet period: wait out cascading add → sections → gift-wrap requests.
    state.timer = window.setTimeout(flushCart, 1000);
  }

  function flushCart() {
    if (state.cartRequests > 0) {
      state.timer = window.setTimeout(flushCart, 400);
      return;
    }
    if (state.cartFetching) {
      state.cartFetchQueued = true;
      return;
    }
    if (!state.cartDirty && !state.meta) return;
    var currentMeta = state.meta || { action: 'update' };
    var known = state.pendingCart;
    state.meta = null;
    state.pendingCart = null;
    state.cartDirty = false;
    state.cartFetching = true;
    state.cartFetchQueued = false;
    // Always re-fetch after multi-step adds so we never emit an intermediate cart.
    var ready = fetchCart().catch(function () {
      return known || null;
    });
    ready.then(function (cart) {
      state.cartFetching = false;
      if (state.cartRequests > 0 || state.cartFetchQueued || state.cartDirty || state.meta) {
        preferCartMeta(state.meta || currentMeta);
        scheduleCart(state.meta || currentMeta);
        return;
      }
      if (cart) trackCart(cart, currentMeta);
    }).catch(function () {
      state.cartFetching = false;
      if (state.cartFetchQueued || state.meta || state.cartDirty) {
        preferCartMeta(state.meta || currentMeta);
        scheduleCart(state.meta || currentMeta);
      }
    });
  }

  function finishCartRequest(meta, data) {
    state.cartRequests = Math.max(0, state.cartRequests - 1);
    var failed = !!(data && (data.errors || (typeof data.status === 'number' && data.status >= 400)));
    var child = !!(data && !failed && isChildItem(data));
    if (data && !failed && !child && isFullCart(data)) state.pendingCart = normalizeCart(data);
    if (Date.now() < state.wishlistCartMoveUntil) return;
    // Child fee/wrap lines should not create their own cart_update; parent action owns it.
    if (!failed && !child) scheduleCart(meta);
    else if (!failed && child && state.meta) scheduleCart(state.meta);
    else if (state.meta) scheduleCart(state.meta);
  }

  function attachListingBloom(init, meta) {
    var body = init && init.body;
    if (!body || typeof body.get !== 'function' || body.get('properties[_bloomreach_product_json]')) return;
    var button = (meta && meta.button) || (state.pending && state.pending.button);
    if (!button) return;
    var details = cartSourceFromButton(button);
    if (!details) return;
    rememberAddedDetails(details.shopify_variant_id || body.get('id'), details);
    var payload = defined(details);
    if (!payload.product_id && !payload.sku_id && !payload.categories_path && !payload.color && !tagList(payload.tags).length) return;
    body.set('properties[_bloomreach_product_json]', JSON.stringify(payload));
  }

  var wishlistSent = {};
  var wishlistMemory = {};
  var wishlistItems = {};
  try {
    wishlistMemory = JSON.parse(window.sessionStorage.getItem('exponea_wishlist_products') || '{}') || {};
    wishlistItems = JSON.parse(window.sessionStorage.getItem('exponea_wishlist_items') || '{}') || {};
  } catch (error) {
    wishlistMemory = wishlistMemory || {};
    wishlistItems = {};
  }

  function rememberWishlistProduct(product, variant) {
    if (!product || product.id == null || product.id === '') return;
    var id = String(product.id);
    var current = wishlistMemory[id] || {};
    var savedVariant = current.variant || {};
    var categories = categoryFromHelium(product.categories).category_level_1 ? product.categories : (current.categories || null);
    // Keep prior selection snapshot; product JSON metafields must not overwrite engraving.
    var engravingFlag = current.engraving != null ? !!current.engraving : false;
    var giftFlag = current.gift_wrapping != null ? !!current.gift_wrapping : false;
    if (product._selection_engraving != null) engravingFlag = !!product._selection_engraving;
    if (product._selection_gift_wrapping != null) giftFlag = !!product._selection_gift_wrapping;
    var meta = metafieldCapability(product);
    wishlistMemory[id] = {
      id: product.id,
      title: product.title || current.title || '',
      vendor: product.vendor || current.vendor || '',
      type: product.type || current.type || '',
      tags: (product.tags && product.tags.length) ? product.tags : (current.tags || []),
      color: product.color || current.color || '',
      size: product.size || current.size || '',
      handle: product.handle || current.handle || '',
      options: (product.options && product.options.length) ? product.options : (current.options || []),
      categories: categories,
      category_level_1: product.category_level_1 || current.category_level_1 || '',
      category_level_2: product.category_level_2 || current.category_level_2 || '',
      category_level_3: product.category_level_3 || current.category_level_3 || '',
      engraving: engravingFlag,
      gift_wrapping: giftFlag,
      item_engraving_flag: meta.item_engraving_flag,
      item_gift_wrapping_flag: meta.item_gift_wrapping_flag,
      line: current.line || null,
      variant: {
        id: (variant && variant.id) || savedVariant.id || '',
        sku: (variant && variant.sku) || savedVariant.sku || '',
        barcode: (variant && variant.barcode) || savedVariant.barcode || '',
        price: (variant && variant.price) || savedVariant.price || 0,
        compare_at_price: (variant && variant.compare_at_price) || savedVariant.compare_at_price || 0,
        option1: (variant && variant.option1) || savedVariant.option1 || '',
        option2: (variant && variant.option2) || savedVariant.option2 || '',
        option3: (variant && variant.option3) || savedVariant.option3 || ''
      }
    };
    try {
      window.sessionStorage.setItem('exponea_wishlist_products', JSON.stringify(wishlistMemory));
    } catch (error) {}
  }

  function rememberWishlistLineSnapshot(line, product, variant) {
    if (!line) return;
    var id = String((product && product.id) || line.shopify_parent_id || '');
    if (!id) return;
    rememberWishlistProduct(product || { id: id }, variant);
    var saved = wishlistMemory[id] || { id: id, variant: {} };
    var snapshot = {};
    Object.keys(line).forEach(function (key) {
      if (key === 'action' || key === 'button_copy' || key === 'button_type') return;
      if (key === 'item_engraving_flag' || key === 'item_gift_wrapping_flag') return;
      if (line[key] == null || line[key] === '') return;
      snapshot[key] = line[key];
    });
    if (line.engraving != null) snapshot.engraving = !!line.engraving;
    if (line.gift_wrapping != null) snapshot.gift_wrapping = !!line.gift_wrapping;
    saved.line = snapshot;
    if (snapshot.engraving != null) saved.engraving = !!snapshot.engraving;
    if (snapshot.gift_wrapping != null) saved.gift_wrapping = !!snapshot.gift_wrapping;
    if (line.item_engraving_flag != null) saved.item_engraving_flag = !!line.item_engraving_flag;
    if (line.item_gift_wrapping_flag != null) saved.item_gift_wrapping_flag = !!line.item_gift_wrapping_flag;
    wishlistMemory[id] = saved;
    try {
      window.sessionStorage.setItem('exponea_wishlist_products', JSON.stringify(wishlistMemory));
    } catch (error) {}
  }

  function restoreWishlistLineSnapshot(payload, product, variant) {
    var saved = findWishlistMemory(product, variant);
    if (!saved || !saved.line) return payload || {};
    var merged = Object.assign({}, saved.line, payload || {});
    // Selection only — never promote metafield item_* into engraving.
    if (merged.engraving == null && saved.engraving != null) merged.engraving = !!saved.engraving;
    if (merged.gift_wrapping == null && saved.gift_wrapping != null) merged.gift_wrapping = !!saved.gift_wrapping;
    if (merged.engraving == null) merged.engraving = false;
    if (merged.gift_wrapping == null) merged.gift_wrapping = false;
    delete merged.item_engraving_flag;
    delete merged.item_gift_wrapping_flag;
    return merged;
  }

  // Cart line for a wishlist product (PDP remove after ATC needs live gift/engraving props).
  function cartItemForWishlist(product, variant) {
    var items = (state.cart && state.cart.items) || [];
    var parentId = String((product && product.id) || '');
    var variantId = String((variant && variant.id) || '');
    var index;
    for (index = 0; index < items.length; index += 1) {
      var item = items[index];
      if (!item || isChildProps(item.properties)) continue;
      if (variantId && String(item.id) === variantId) return item;
      if (parentId && String(item.product_id) === parentId) return item;
      var bloom = item.bloom || {};
      if (parentId && String(bloom.shopify_parent_id || '') === parentId) return item;
      if (variantId && String(bloom.shopify_variant_id || '') === variantId) return item;
    }
    return null;
  }

  function pdpHasGiftOptionUi() {
    try {
      return !!(
        document.querySelector(
          '[data-engraving-summary], [data-giftwrap-summary], [data-engraving-toggle], [data-giftwrap-toggle], [data-engraving-remove], [data-giftwrap-remove], [data-engraving-hidden-id], [data-giftwrap-hidden-id]'
        )
      );
    } catch (error) {
      return false;
    }
  }

  // Live selection for wishlist emit.
  // On PDP with gift-option drawers: current drawer state wins (cleared drawers → false,
  // even if the add-time snapshot still has true). Elsewhere: snapshot + cart + page.
  function wishlistLiveSelection(product, variant, line) {
    var pageLive = pageSelectionFlags();
    if ((page.page_type === 'product' || pageType() === 'pdp') && pdpHasGiftOptionUi()) {
      return {
        engraving: !!pageLive.engraving,
        gift_wrapping: !!pageLive.gift_wrapping
      };
    }
    var selected = {
      engraving: !!(line && line.engraving),
      gift_wrapping: !!(line && line.gift_wrapping)
    };
    var saved = findWishlistMemory(product, variant);
    if (saved) {
      if (saved.engraving) selected.engraving = true;
      if (saved.gift_wrapping) selected.gift_wrapping = true;
      if (saved.line) {
        if (saved.line.engraving) selected.engraving = true;
        if (saved.line.gift_wrapping) selected.gift_wrapping = true;
      }
    }
    var cartLive = selectionFlags({ item: cartItemForWishlist(product, variant) });
    if (cartLive.engraving) selected.engraving = true;
    if (cartLive.gift_wrapping) selected.gift_wrapping = true;
    if (pageLive.engraving) selected.engraving = true;
    if (pageLive.gift_wrapping) selected.gift_wrapping = true;
    return selected;
  }

  function findWishlistMemory(product, variant) {
    if (!product && !variant) return null;
    var byId = product && product.id != null && product.id !== '' ? wishlistMemory[String(product.id)] : null;
    if (byId) return byId;
    var handle = product && product.handle ? String(product.handle) : '';
    var variantId = String((variant && variant.id) || '');
    var keys = Object.keys(wishlistMemory);
    var index;
    for (index = 0; index < keys.length; index += 1) {
      var saved = wishlistMemory[keys[index]];
      if (!saved) continue;
      if (handle && saved.handle && saved.handle === handle) return saved;
      if (variantId && saved.variant && String(saved.variant.id) === variantId) return saved;
    }
    return null;
  }

  function fillWishlistProduct(product, variant) {
    if (!product) return;
    var saved = findWishlistMemory(product, variant);
    if (!saved) return;
    var savedVariant = saved.variant || {};
    if (!product.id && saved.id) product.id = saved.id;
    if (!product.title) product.title = saved.title || '';
    if (!product.vendor) product.vendor = saved.vendor || '';
    if (!product.type) product.type = saved.type || '';
    if ((!product.tags || !product.tags.length) && saved.tags && saved.tags.length) product.tags = saved.tags;
    if (!product.color) product.color = saved.color || '';
    if (!product.size) product.size = saved.size || '';
    if (!product.handle) product.handle = saved.handle || '';
    if ((!product.options || !product.options.length) && saved.options && saved.options.length) product.options = saved.options;
    if (!product.category_level_1) product.category_level_1 = saved.category_level_1 || '';
    if (!product.category_level_2) product.category_level_2 = saved.category_level_2 || '';
    if (!product.category_level_3) product.category_level_3 = saved.category_level_3 || '';
    if (!categoryFromHelium(product.categories).category_level_1 && saved.categories) product.categories = saved.categories;
    if (saved.engraving != null) product._selection_engraving = !!saved.engraving;
    if (saved.gift_wrapping != null) product._selection_gift_wrapping = !!saved.gift_wrapping;
    if (!variant) return;
    if (!variant.id) variant.id = savedVariant.id || '';
    if (!variant.sku) variant.sku = savedVariant.sku || '';
    if (!variant.barcode) variant.barcode = savedVariant.barcode || '';
    if (!variant.price) variant.price = savedVariant.price || 0;
    if (!variant.compare_at_price) variant.compare_at_price = savedVariant.compare_at_price || 0;
    if (!variant.option1) variant.option1 = savedVariant.option1 || '';
    if (!variant.option2) variant.option2 = savedVariant.option2 || '';
    if (!variant.option3) variant.option3 = savedVariant.option3 || '';
  }

  function wishlistLineIncomplete(line) {
    if (!line) return true;
    if (!line.title || !line.brand || !line.product_id || !line.sku_id) return true;
    if (!line.category_level_1 && !line.categories_path) return true;
    if (!(Number(line.price) > 0)) return true;
    return false;
  }

  function saveWishlistItems() {
    try {
      window.sessionStorage.setItem('exponea_wishlist_items', JSON.stringify(wishlistItems));
    } catch (error) {}
  }

  function writeWishlistItem(item) {
    if (!item) return;
    var key = String(item.shopify_variant_id || item.shopify_parent_id || '');
    if (!key) return;
    var current = wishlistItems[key] || {};
    var saved = wishlistMemory[String(item.shopify_parent_id || '')] || {};
    wishlistItems[key] = {
      product_id: item.product_id || current.product_id || '',
      sku: item.sku || current.sku || '',
      shopify_parent_id: item.shopify_parent_id || current.shopify_parent_id || '',
      shopify_variant_id: item.shopify_variant_id || current.shopify_variant_id || '',
      quantity: 1,
      engraving: item.engraving != null
        ? !!item.engraving
        : !!(current.engraving != null ? current.engraving : saved.engraving),
      gift_wrapping: item.gift_wrapping != null
        ? !!item.gift_wrapping
        : !!(current.gift_wrapping != null ? current.gift_wrapping : saved.gift_wrapping),
      item_engraving_flag: item.item_engraving_flag != null
        ? !!item.item_engraving_flag
        : !!(current.item_engraving_flag != null ? current.item_engraving_flag : saved.item_engraving_flag),
      item_gift_wrapping_flag: item.item_gift_wrapping_flag != null
        ? !!item.item_gift_wrapping_flag
        : !!(current.item_gift_wrapping_flag != null ? current.item_gift_wrapping_flag : saved.item_gift_wrapping_flag)
    };
  }

  function buttonWishlistItem(button) {
    if (!button || !button.getAttribute) return null;
    var parentId = button.getAttribute('data-product') || '';
    var variantId = button.getAttribute('data-variant') || '';
    if (!parentId && !variantId) return null;
    return {
      product_id: button.getAttribute('data-barcode') || '',
      sku: button.getAttribute('data-sku') || '',
      shopify_parent_id: String(parentId),
      shopify_variant_id: String(variantId)
    };
  }

  function syncWishlistMembers(product, variant, action) {
    var currentId = String((product && product.id) || '');
    var currentVariant = String((variant && variant.id) || '');
    if (action === 'remove') {
      Object.keys(wishlistItems).forEach(function (key) {
        var saved = wishlistItems[key];
        if (!saved) return;
        if ((currentId && saved.shopify_parent_id === currentId) || (currentVariant && (saved.shopify_variant_id === currentVariant || key === currentVariant))) {
          delete wishlistItems[key];
        }
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]'), function (button) {
      if (!wishlistMarked(button)) return;
      var item = buttonWishlistItem(button);
      if (!item || (action === 'remove' && item.shopify_parent_id === currentId)) return;
      writeWishlistItem(item);
    });
    if (action !== 'remove' && product) {
      var selected = selectionFlags({ usePage: true });
      var meta = metafieldCapability(product);
      writeWishlistItem({
        product_id: String((variant && variant.barcode) || ''),
        sku: String((variant && variant.sku) || ''),
        shopify_parent_id: currentId,
        shopify_variant_id: String((variant && variant.id) || ''),
        engraving: product._selection_engraving != null ? product._selection_engraving : selected.engraving,
        gift_wrapping: product._selection_gift_wrapping != null ? product._selection_gift_wrapping : selected.gift_wrapping,
        item_engraving_flag: meta.item_engraving_flag,
        item_gift_wrapping_flag: meta.item_gift_wrapping_flag
      });
    }
    saveWishlistItems();
  }

  function wishlistCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return parts.pop().split(';').shift() || '';
  }

  function wishlistIdentity() {
    var customer = wishlistCookie('ms_customer_id');
    if (!customer || customer === '0' || customer === 'undefined' || customer === 'null') {
      var field = document.getElementById('ms_customer_id');
      customer = (field && field.value) || '';
    }
    if (customer && customer !== '0' && customer !== 'undefined' && customer !== 'null') return { customer_id: customer };
    var device = wishlistCookie('new_unique_device_id');
    if (!device) return null;
    return { device_id: device };
  }

  function knownWishlistIds(parentId, variantId) {
    var button = null;
    if (variantId) {
      button = document.querySelector('#mswishlistbutton[data-variant="' + variantId + '"], .mswishlistbutton[data-variant="' + variantId + '"], [id^="mswishlistbutton"][data-variant="' + variantId + '"]');
    }
    if (!button && parentId) {
      button = document.querySelector('#mswishlistbutton[data-product="' + parentId + '"], .mswishlistbutton[data-product="' + parentId + '"], [id^="mswishlistbutton"][data-product="' + parentId + '"]');
    }
    var saved = wishlistMemory[String(parentId || '')];
    var savedVariant = (saved && saved.variant) || {};
    return {
      sku: String((button && button.getAttribute('data-sku')) || savedVariant.sku || ''),
      barcode: String((button && button.getAttribute('data-barcode')) || savedVariant.barcode || '')
    };
  }

  var variantIdentity = {};
  var wishlistFetchSeq = 0;
  var wishlistFetchPromise = null;

  function loadVariantIdentity(variantId) {
    variantId = String(variantId || '');
    if (!variantId) return Promise.resolve({ sku: '', barcode: '' });
    if (variantIdentity[variantId]) return Promise.resolve(variantIdentity[variantId]);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return fetch(root + 'variants/' + encodeURIComponent(variantId) + '.js', { credentials: 'same-origin' }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (data) {
      var details = {
        sku: (data && data.sku) || '',
        barcode: (data && data.barcode) || ''
      };
      variantIdentity[variantId] = details;
      return details;
    }).catch(function () {
      return { sku: '', barcode: '' };
    });
  }

  function applyWishlistRows(rows, seq) {
    return Promise.all(rows.map(function (row) {
      var variantId = String(row.pro_variant_id || row.variant_id || '');
      return loadVariantIdentity(variantId).then(function (details) {
        return { row: row, details: details };
      });
    })).then(function (loaded) {
      // Stale responses must not chain onto a newer refresh (that delayed older events).
      if (seq !== wishlistFetchSeq) return false;
      wishlistItems = {};
      loaded.forEach(function (entry) {
        var row = entry.row || {};
        var parentId = String(row.product_id || '');
        var variantId = String(row.pro_variant_id || row.variant_id || '');
        var known = knownWishlistIds(parentId, variantId);
        writeWishlistItem({
          product_id: known.barcode || entry.details.barcode || '',
          sku: known.sku || entry.details.sku || '',
          shopify_parent_id: parentId,
          shopify_variant_id: variantId
        });
      });
      saveWishlistItems();
      return true;
    });
  }

  function refreshWishlistLists() {
    var identity = wishlistIdentity();
    var shop = (window.Shopify && window.Shopify.shop) || '';
    if (!identity || !shop) return Promise.resolve(false);
    var seq = ++wishlistFetchSeq;
    var promise = fetch('https://wishlistapp.binaryic.in/api/V1/wishlist/get', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ shop_url: shop }, identity))
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (seq !== wishlistFetchSeq) return false;
      var rows = data && Array.isArray(data.data) ? data.data : [];
      if (!rows.length) {
        if (data && data.success === false && /no products/i.test(String(data.message || ''))) {
          wishlistItems = {};
          saveWishlistItems();
          return true;
        }
        return false;
      }
      return applyWishlistRows(rows, seq);
    }).catch(function () {
      if (seq !== wishlistFetchSeq) return false;
      return false;
    });
    wishlistFetchPromise = promise;
    return promise;
  }

  function publishWishlist(key, line, extra, product, variant, action) {
    line = line || {};
    var handle = (product && product.handle) || line.handle || '';
    var productId = String((product && product.id) || line.shopify_parent_id || '');
    var variantId = String((variant && variant.id) || line.shopify_variant_id || '');
    // One click = one wishlist event. Block opposite/duplicate emits for the same gesture.
    if (!wishlistGestureAllows(productId, variantId, action)) return;
    if (!wishlistOnce(key)) {
      markWishlistGestureTracked(productId, variantId, action);
      return;
    }
    markWishlistGestureTracked(productId, variantId, action);

    // On remove, keep the product in list props for this emit (same shape as add), then sync membership.
    var listProps = null;
    if (action === 'remove') {
      var removeSnapshot = restoreWishlistLineSnapshot(Object.assign({}, line), product, variant);
      var removeSelected = wishlistLiveSelection(product, variant, removeSnapshot);
      Object.assign(removeSnapshot, removeSelected);
      writeWishlistItem({
        product_id: line.product_id || (variant && variant.barcode) || '',
        sku: line.sku_id || line.variant_id || (variant && variant.sku) || '',
        shopify_parent_id: productId,
        shopify_variant_id: variantId,
        engraving: removeSelected.engraving,
        gift_wrapping: removeSelected.gift_wrapping,
        item_engraving_flag: removeSelected.engraving,
        item_gift_wrapping_flag: removeSelected.gift_wrapping
      });
      listProps = wishlistLists();
      syncWishlistMembers(product, variant, action);
    } else {
      syncWishlistMembers(product, variant, action);
      listProps = wishlistLists();
    }

    var emitted = false;
    function emit(catalogProduct) {
      if (emitted) return;
      emitted = true;
      try {
        if (catalogProduct) {
          if (!line.title && catalogProduct.title) line.title = catalogProduct.title;
          if (!line.shopify_parent_id && catalogProduct.id) line.shopify_parent_id = String(catalogProduct.id);
          if (!line.brand && catalogProduct.vendor) line.brand = catalogProduct.vendor;
          if (!line.product_type && catalogProduct.type) line.product_type = catalogProduct.type;
          applyCatalogProductLine(line, catalogProduct, variantId);
          var catalogVariant = (catalogProduct.variants || []).find(function (entry) {
            return String(entry.id) === String(variantId);
          }) || (catalogProduct.variants || [])[0];
          if (catalogVariant) {
            if (!line.shopify_variant_id) line.shopify_variant_id = String(catalogVariant.id || '');
            if (!line.size) line.size = optionValue(catalogProduct, catalogVariant, SIZE_OPTION) || '';
            if (!line.color) line.color = catalogProduct.color || optionValue(catalogProduct, catalogVariant, COLOR_OPTION) || '';
          }
        }
        syncPrices(line, line.price, line.original_price);
        var price = Number(line.price) || 0;
        line.total_price = price;
        line.total_price_local_currency = price;
        Object.assign(line, taxFields(price));
        if (action === 'remove') {
          line = restoreWishlistLineSnapshot(line, product, variant);
          Object.assign(line, wishlistLiveSelection(product, variant, line));
          line.action = 'remove';
          line.button_copy = 'Remove from wishlist';
        } else {
          var wishSelected = wishlistLiveSelection(product, variant, line);
          Object.assign(line, wishSelected);
          if (product) {
            product._selection_engraving = line.engraving;
            product._selection_gift_wrapping = line.gift_wrapping;
          }
        }
        delete line.item_engraving_flag;
        delete line.item_gift_wrapping_flag;
        assignViewItemStock(
          variantId,
          productId,
          handle || (product && product.handle) || (catalogProduct && catalogProduct.handle) || '',
          true
        ).then(function (stock) {
          if (stock != null) line.stock_level = stock;
          else if (stockLevel(line) == null) line.stock_level = 0;
          if (action !== 'remove') rememberWishlistLineSnapshot(line, product, variant);
          track('wishlist', withCategoryIdPrefix(Object.assign({}, line, listProps || wishlistLists(), extra)));
        }).catch(function () {});
        return;
      } catch (error) {
        try {
          var fallbackSelected = wishlistLiveSelection(product, variant, action === 'remove'
            ? restoreWishlistLineSnapshot({}, product, variant)
            : line);
          var fallbackPayload = Object.assign({
            action: action,
            shopify_parent_id: productId,
            shopify_variant_id: variantId,
            title: (line && line.title) || (product && product.title) || '',
            button_copy: action === 'remove' ? 'Remove from wishlist' : 'Add to wishlist',
            page_type: wishlistPageType(),
            total_quantity: 1,
            engraving: !!fallbackSelected.engraving,
            gift_wrapping: !!fallbackSelected.gift_wrapping
          }, extra || {});
          var fallbackStock = pageVariantInventory(variantId, productId);
          if (fallbackStock != null) fallbackPayload.stock_level = fallbackStock;
          track('wishlist', withCategoryIdPrefix(withStock(fallbackPayload, line)));
        } catch (err) {}
      }
    }

    // Enrich when attributes are incomplete, but never block the event on a slow/hung catalog fetch.
    if (wishlistLineIncomplete(line) && (handle || productId)) {
      var pending = true;
      resolveCatalogProduct(handle, productId).then(function (catalogProduct) {
        if (!pending) return;
        pending = false;
        emit(catalogProduct);
      }).catch(function () {
        if (!pending) return;
        pending = false;
        emit(null);
      });
      window.setTimeout(function () {
        if (!pending) return;
        pending = false;
        emit(null);
      }, 1000);
    } else {
      emit(null);
    }

    // Keep server list in sync in the background; never block tracking on it.
    refreshWishlistLists().catch(function () {});
  }

  function wishlistLists() {
    return cartLists(Object.keys(wishlistItems).map(function (key) {
      var item = wishlistItems[key];
      var saved = wishlistMemory[String(item.shopify_parent_id || '')] || {};
      var selectedEngraving = item.engraving != null ? !!item.engraving : !!(saved.engraving);
      var selectedGift = item.gift_wrapping != null ? !!item.gift_wrapping : !!(saved.gift_wrapping);
      return {
        barcode: item.product_id,
        sku: item.sku,
        product_id: item.shopify_parent_id,
        id: item.shopify_variant_id,
        quantity: 1,
        engraving: selectedEngraving,
        gift_wrapping: selectedGift,
        // List flags mirror selection (not product metafield capability).
        item_engraving_flag: selectedEngraving,
        item_gift_wrapping_flag: selectedGift,
        bloom: {
          product_id: item.product_id,
          sku_id: item.sku,
          shopify_parent_id: item.shopify_parent_id,
          shopify_variant_id: item.shopify_variant_id,
          engraving: selectedEngraving,
          gift_wrapping: selectedGift,
          item_engraving_flag: selectedEngraving,
          item_gift_wrapping_flag: selectedGift
        },
        properties: {}
      };
    }));
  }

  function wishlistOnce(key) {
    var now = Date.now();
    var shared = window.__afwjWishlistSent || (window.__afwjWishlistSent = {});
    if ((shared[key] && now - shared[key] < 2500) || (wishlistSent[key] && now - wishlistSent[key] < 2500)) return false;
    shared[key] = now;
    wishlistSent[key] = now;
    return true;
  }

  function recentWishlistDecision(productId) {
    productId = String(productId || '');
    if (!productId) return '';
    var now = Date.now();
    var shared = window.__afwjWishlistSent || {};
    var addAt = Math.max(Number(shared[productId + ':add']) || 0, Number(wishlistSent[productId + ':add']) || 0);
    var removeAt = Math.max(Number(shared[productId + ':remove']) || 0, Number(wishlistSent[productId + ':remove']) || 0);
    if (addAt && now - addAt < 2500 && addAt >= removeAt) return 'add';
    if (removeAt && now - removeAt < 2500 && removeAt >= addAt) return 'remove';
    return '';
  }

  function setPendingWishlistUi(data) {
    pendingWishlistUi = data || null;
    if (!data) return;
    window.setTimeout(function () {
      if (pendingWishlistUi === data) pendingWishlistUi = null;
    }, 5000);
  }

  var wishlistGesture = null;

  function beginWishlistGesture(productId, variantId, action) {
    wishlistGesture = {
      productId: String(productId || ''),
      variantId: String(variantId || ''),
      action: action === 'remove' ? 'remove' : 'add',
      at: Date.now(),
      tracked: false
    };
    window.setTimeout(function () {
      if (wishlistGesture && wishlistGesture.at && Date.now() - wishlistGesture.at >= 4000) {
        wishlistGesture = null;
      }
    }, 4100);
  }

  function wishlistGestureMatches(productId, variantId) {
    if (!wishlistGesture || Date.now() - wishlistGesture.at > 4000) return false;
    productId = String(productId || '');
    variantId = String(variantId || '');
    if (wishlistGesture.productId && productId && wishlistGesture.productId === productId) return true;
    if (wishlistGesture.variantId && variantId && wishlistGesture.variantId === variantId) return true;
    // Click happened but ids were not known yet — treat as same gesture.
    if (!wishlistGesture.productId && !wishlistGesture.variantId) return true;
    if (!productId && !variantId) return true;
    return false;
  }

  function wishlistGestureAllows(productId, variantId, action) {
    if (!wishlistGesture || Date.now() - wishlistGesture.at > 4000) return true;
    if (!wishlistGestureMatches(productId, variantId)) return true;
    if (wishlistGesture.action && wishlistGesture.action !== action) return false;
    if (wishlistGesture.tracked) return false;
    return true;
  }

  function markWishlistGestureTracked(productId, variantId, action) {
    if (!wishlistGestureMatches(productId, variantId)) return;
    if (wishlistGesture.action && action && wishlistGesture.action !== action) return;
    wishlistGesture.tracked = true;
    if (productId && !wishlistGesture.productId) wishlistGesture.productId = String(productId);
    if (variantId && !wishlistGesture.variantId) wishlistGesture.variantId = String(variantId);
  }

  function readRequestBody(body) {
    var text = '';
    if (!body) return {};
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var formData = {};
      try {
        body.forEach(function (value, key) {
          if (key) formData[key] = value;
        });
      } catch (error) {}
      return formData;
    }
    if (typeof body === 'string') text = body;
    else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) text = body.toString();
    var data = {};
    if (!text) return data;
    if (text.charAt(0) === '{') {
      try { return JSON.parse(text) || {}; } catch (error) { return data; }
    }
    text.split('&').forEach(function (pair) {
      if (!pair) return;
      var splitAt = pair.indexOf('=');
      var key = decodeURIComponent(splitAt === -1 ? pair : pair.slice(0, splitAt));
      var value = decodeURIComponent((splitAt === -1 ? '' : pair.slice(splitAt + 1)).replace(/\+/g, ' '));
      if (key) data[key] = value;
    });
    return data;
  }

  var pendingWishlistUi = null;

  function wishlistApiCall(url, init) {
    var href = String(url || '');
    // Binaryic wishlist app endpoints used for toggle / remove (exclude list/get).
    if (!/wishlistapp\.binaryic\.in/i.test(href) && !/\/wishlist\//i.test(href)) return null;
    if (/\/wishlist\/get(\/|\?|$)|getWishlistIconState|getWishlist(?!Product)/i.test(href)) return null;
    if (!/addOrRemoveWishlistProduct|addRemoveWishlist|removeWishlist|deleteWishlist|removeFromWishlist|removeWishlistProduct|deleteWishlistProduct|remove_product|delete_product/i.test(href)) {
      return null;
    }
    var method = (init && init.method) || 'GET';
    if (String(method).toUpperCase() !== 'POST') return null;
    var data = readRequestBody(init && init.body);
    var forcedRemove = /removeWishlist|deleteWishlist|removeFromWishlist|removeWishlistProduct|deleteWishlistProduct|remove_product|delete_product/i.test(href);
    return {
      url: href,
      productId: data.product_id || data.productId || data.pro_id || '',
      variantId: data.variant_id || data.variantId || data.pro_variant_id || '',
      forcedAction: forcedRemove ? 'remove' : ''
    };
  }

  function wishlistActionFromResponse(data, call) {
    if (call && call.forcedAction) return call.forcedAction;
    if (!data) return '';
    // Explicit API status always wins.
    var status = String(data.product_check_status || data.status || data.action || '').toLowerCase();
    if (status === 'success_product' || status === 'added' || status === 'add') return 'add';
    if (/remove|deleted|delete/.test(status)) return 'remove';
    if (data.removed === true || data.is_removed === true) return 'remove';
    if (data.added === true || data.is_added === true) return 'add';
    if (data.error || data.success === false) return '';
    var callProduct = String((call && call.productId) || '');
    var callVariant = String((call && call.variantId) || '');
    // Ambiguous response: trust the click intent for this product (prevents add+remove pairs).
    if (wishlistGesture && wishlistGesture.action && Date.now() - wishlistGesture.at < 4000) {
      if (wishlistGestureMatches(callProduct, callVariant) || !callProduct) {
        return wishlistGesture.action;
      }
    }
    if (pendingWishlistUi && pendingWishlistUi.action && Date.now() - pendingWishlistUi.at < 5000) {
      var pendingProduct = String(pendingWishlistUi.productId || '');
      if (pendingProduct && (!callProduct || callProduct === pendingProduct)) {
        return pendingWishlistUi.action;
      }
    }
    var href = String((call && call.url) || '');
    // Classic heart toggle with no clear status: only treat as remove when no add intent exists.
    if (/addOrRemoveWishlistProduct/i.test(href)) return 'remove';
    // Cart "move to wishlist" uses addRemoveWishlist and is an add.
    if (/addRemoveWishlist/i.test(href) && !/addOrRemoveWishlistProduct/i.test(href)) return 'add';
    return '';
  }

  function wishlistMoveCall(url, init) {
    if (!/moveToProductWishlist/i.test(String(url || ''))) return null;
    var method = (init && init.method) || 'GET';
    if (String(method).toUpperCase() !== 'POST') return null;
    var data = readRequestBody(init && init.body);
    return {
      productId: data.product_id || data.productId || '',
      variantId: data.variant_id || data.variantId || ''
    };
  }

  var pendingWishlistMove = null;

  function trackMovedWishlist(call) {
    var variantId = String((call && call.variantId) || '');
    var cartItem = state.cart && (state.cart.items || []).find(function (item) {
      return String(item.id) === variantId && !isChildProps(item.properties);
    });
    if (!cartItem && pendingWishlistMove && String(pendingWishlistMove.variantId) === variantId) {
      cartItem = pendingWishlistMove.item;
    }
    if (!cartItem && pendingWishlistMove && pendingWishlistMove.item) cartItem = pendingWishlistMove.item;
    pendingWishlistMove = null;
    if (!cartItem) return;
    var line;
    try {
      line = withLists(lineFromCartItem(cartItem), ['categories_path']);
      var cartCategories = categoryFromHelium(cartItem.categories);
      ['category_level_1', 'category_level_2', 'category_level_3'].forEach(function (key) {
        if (!line[key] && cartCategories[key]) line[key] = cartCategories[key];
      });
      if (line.categories_ids) line.categories_ids = arrayValue(line.categories_ids);
      line.tags = tagsValue(line.tags);
      // Cart line selection wins (gift wrap / engraving saved on cart).
      var fromCart = selectionFlags({ item: cartItem, usePage: true });
      if (cartItem.gift_wrapping) fromCart.gift_wrapping = true;
      if (cartItem.engraving) fromCart.engraving = true;
      Object.assign(line, fromCart);
    } catch (error) {
      return;
    }
    publishWishlist(String(line.shopify_parent_id || variantId || 'wishlist') + ':add', line, {
      action: 'add',
      button_type: 'Cart',
      button_copy: 'Move to Wishlist',
      page_type: wishlistPageType(),
      total_quantity: 1
    }, {
      id: line.shopify_parent_id,
      handle: cartItem.handle || '',
      _selection_engraving: line.engraving,
      _selection_gift_wrapping: line.gift_wrapping,
      item_engraving_flag: cartItem.item_engraving_flag,
      item_gift_wrapping_flag: cartItem.item_gift_wrapping_flag
    }, {
      id: line.shopify_variant_id,
      sku: line.sku_id,
      barcode: line.product_id
    }, 'add');
  }

  function installCartHook() {
    if (window.fetch && window.fetch.__exponea) return;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = requestUrl(input);
      var wishlistCall = wishlistApiCall(url, init);
      var moveCall = wishlistMoveCall(url, init);
      if (wishlistCall || moveCall) {
        return nativeFetch(input, init).then(function (response) {
          if (response && response.ok && response.clone) {
            response.clone().json().then(function (data) {
              if (!data) return;
              if (moveCall) {
                if (data.success === false || data.error) return;
                trackMovedWishlist(moveCall);
                return;
              }
              var action = wishlistActionFromResponse(data, wishlistCall);
              if (!action) return;
              if (wishlistCall && !wishlistCall.productId && pendingWishlistUi && pendingWishlistUi.productId) {
                wishlistCall.productId = pendingWishlistUi.productId;
                wishlistCall.variantId = wishlistCall.variantId || pendingWishlistUi.variantId || '';
              }
              trackWishlistApi(wishlistCall, action);
              pendingWishlistUi = null;
            }).catch(function () {});
          }
          return response;
        });
      }
      if (!/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) || !changesCart(url, init)) return nativeFetch(input, init);
      var meta = actionFromRequest(url, init);
      if (/\/cart\/add(\.js)?/.test(url)) attachListingBloom(init, meta);
      state.cartRequests += 1;
      var finished = false;
      function done(data) {
        if (finished) return;
        finished = true;
        finishCartRequest(meta, data);
      }
      return nativeFetch(input, init).then(function (response) {
        if (response && response.ok && response.clone) {
          response.clone().json().then(function (data) {
            done(data);
          }).catch(function () {
            done(null);
          });
        } else {
          done(response && response.status >= 400 ? { status: response.status, errors: true } : null);
        }
        return response;
      }, function (error) {
        done({ status: 400, errors: true });
        throw error;
      });
    };
    window.fetch.__exponea = true;
    installCartXhr();
  }

  function installCartXhr() {
    if (!window.XMLHttpRequest || XMLHttpRequest.prototype.__exponea) return;
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__exponeaUrl = String(url || '');
      this.__exponeaMethod = method;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.__exponeaUrl || '';
      var init = { method: this.__exponeaMethod || 'POST', body: body };
      var wishlistCall = wishlistApiCall(url, init);
      var moveCall = wishlistMoveCall(url, init);
      if (wishlistCall || moveCall) {
        var wishlistXhr = this;
        wishlistXhr.addEventListener('load', function () {
          if (wishlistXhr.status >= 400) return;
          var data = null;
          try { data = JSON.parse(wishlistXhr.responseText); } catch (error) {}
          if (!data) return;
          if (moveCall) {
            if (data.success === false || data.error) return;
            trackMovedWishlist(moveCall);
            return;
          }
          var action = wishlistActionFromResponse(data, wishlistCall);
          if (!action) return;
          if (wishlistCall && !wishlistCall.productId && pendingWishlistUi && pendingWishlistUi.productId) {
            wishlistCall.productId = pendingWishlistUi.productId;
            wishlistCall.variantId = wishlistCall.variantId || pendingWishlistUi.variantId || '';
          }
          trackWishlistApi(wishlistCall, action);
          pendingWishlistUi = null;
        });
      } else if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && changesCart(url, init)) {
        var meta = actionFromRequest(url, init);
        var xhr = this;
        state.cartRequests += 1;
        var finished = false;
        function done(data) {
          if (finished) return;
          finished = true;
          finishCartRequest(meta, data);
        }
        xhr.addEventListener('load', function () {
          var data = null;
          try { data = JSON.parse(xhr.responseText); } catch (error) {}
          done(xhr.status >= 400 ? { status: xhr.status, errors: true } : data);
        });
        xhr.addEventListener('error', function () { done({ status: 400, errors: true }); });
        xhr.addEventListener('abort', function () { done({ status: 400, errors: true }); });
      }
      return nativeSend.apply(this, arguments);
    };
    XMLHttpRequest.prototype.__exponea = true;
  }

  function productOnPage() {
    var form = document.querySelector('product-info form[action*="/cart/add"], product-info form[data-type="add-to-cart-form"], form[data-type="add-to-cart-form"]');
    if (form) {
      var found = productFromForm(form);
      if (found) return found;
    }
    var dataEl = document.querySelector('product-info .exponea-product, .exponea-product');
    if (!dataEl) return null;
    try {
      var product = JSON.parse(dataEl.textContent);
    } catch (error) {
      return null;
    }
    if (!product) return null;
    var selectedInput = document.querySelector('product-info [name="id"], product-info .product-variant-id, form[data-type="add-to-cart-form"] [name="id"]');
    var variant = findProductVariant(product, selectedInput && selectedInput.value);
    if (!variant) return null;
    return { product: product, variant: variant };
  }

  function pageHelium(productId) {
    var nodes = document.querySelectorAll('#mswishlistbutton[data-helium], product-info [data-helium], [data-helium]');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      var owner = node.getAttribute('data-product');
      if (productId && owner && String(owner) !== String(productId)) continue;
      var parsed = parseHeliumAttr(node.getAttribute('data-helium'));
      if (parsed && (parsed.h_category || parsed.category_level_1)) return parsed;
    }
    return null;
  }

  function productLocation(product) {
    var path = window.location.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
    if (product && product.handle && path.indexOf('/products/') === -1) path = '/products/' + product.handle;
    return window.location.origin + path;
  }

  function viewItemCategory(product) {
    var parsed = categoryFromHelium(product && product.categories);
    if (!parsed.category_level_1 && !parsed.category_level_2 && !parsed.category_level_3) {
      parsed = categoryFromHelium(pageHelium(product && product.id));
    }
    var level1 = parsed.category_level_1 || '';
    var level2 = parsed.category_level_2 || '';
    var level3 = parsed.category_level_3 || '';
    var levels = [level1, level2, level3].filter(Boolean);
    if (!levels.length) return {};
    return defined({
      category_level_1: level1,
      category_level_2: level2,
      category_level_3: level3,
      categories_path: levels.join(' > '),
      category_id: categoryIdFromLevels(levels),
      categories_ids: arrayValue(prefixCategoryIds(levels.map(categorySlug))),
      color: parsed.color
    });
  }

  function trackViewItem() {
    if (page.page_type !== 'product') return;
    var found = productOnPage();
    if (!found) return;
    var variantKey = String(found.variant.id || '');
    if (state.viewedVariant === variantKey) return;
    state.viewedVariant = variantKey;
    var line = linePayload(found.product, found.variant);
    // Force the required identity mapping for view_item only.
    delete line.product_id;
    delete line.variant_id;
    delete line.sku_id;
    delete line.shopify_parent_id;
    delete line.shopify_variant_id;
    // Metafield capability stays off view_item roots; selection stays false until cart/wishlist.
    delete line.item_engraving_flag;
    delete line.item_gift_wrapping_flag;
    line.engraving = false;
    line.gift_wrapping = false;
    Object.assign(line, productIdentity(found.product, found.variant));
    line.tags = tagsValue(line.tags);
    ['category_level_1', 'category_level_2', 'category_level_3', 'categories_path', 'category_id', 'categories_ids', 'category_name'].forEach(function (key) {
      delete line[key];
    });
    Object.assign(line, viewItemCategory(found.product));
    var price = Number(line.price) || 0;
    var original = Number(line.original_price) || price;
    var discountValue = original > price ? +(original - price).toFixed(2) : 0;
    var discountPercentage = original > price ? Math.round((1 - price / original) * 100) : 0;
    track('view_item', Object.assign(line, {
      os: os(),
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: page.source_type || 'web',
      domain: page.domain || '',
      language: page.language || '',
      local_currency: currency(),
      discount_value: discountValue,
      discount_percentage: discountPercentage,
      stock_level: Number(found.variant.inventory) || 0,
      location: productLocation(found.product)
    }));
  }

  function listingId(value) {
    if (value == null || value === 'null' || value === 'undefined') return '';
    return String(value);
  }

  function listingRows() {
    var rows = { productIds: [], variantIds: [], skuIds: [], parentIds: [], shopifyVariantIds: [] };
    function add(barcode, sku, parentId, variantId) {
      rows.productIds.push(listingId(barcode));
      rows.variantIds.push(listingId(sku));
      rows.skuIds.push(listingId(sku));
      rows.parentIds.push(listingId(parentId));
      rows.shopifyVariantIds.push(listingId(variantId));
    }
    function siblingValue(el, name) {
      var parent = el.parentElement;
      var button = parent && parent.querySelector('.mswishlistbutton');
      if (!button || !button.dataset) return '';
      return button.dataset[name] || '';
    }
    var cards = document.querySelectorAll('.ais-product[data-id]');
    if (cards.length) {
      Array.prototype.forEach.call(cards, function (el) {
        add(
          el.dataset.barcode || siblingValue(el, 'barcode'),
          el.dataset.sku || siblingValue(el, 'sku'),
          el.dataset.id,
          el.dataset.variantId || el.dataset.variant || siblingValue(el, 'variant')
        );
      });
    } else {
      Array.prototype.forEach.call(document.querySelectorAll('#product-grid .mswishlistbutton[data-product]'), function (el) {
        add(el.dataset.barcode, el.dataset.sku, el.dataset.product, el.dataset.variant || el.dataset.variantId);
      });
    }
    var catalog = (page.collection && page.collection.products) || [];
    var byId = {};
    catalog.forEach(function (product) {
      if (product && product.id != null) byId[String(product.id)] = product;
    });
    if (!rows.parentIds.length) {
      if (listingRows.skipCatalog) return rows;
      catalog.forEach(function (product) {
        add(product.barcode, product.sku, product.id, product.variant_id);
      });
      return rows;
    }
    rows.parentIds.forEach(function (id, index) {
      var product = byId[String(id)];
      if (!product) return;
      if (!rows.productIds[index]) rows.productIds[index] = listingId(product.barcode);
      if (!rows.variantIds[index]) rows.variantIds[index] = listingId(product.sku);
      if (!rows.skuIds[index]) rows.skuIds[index] = listingId(product.sku);
      if (!rows.shopifyVariantIds[index]) rows.shopifyVariantIds[index] = listingId(product.variant_id);
    });
    return rows;
  }

  function listingHelium() {
    var nodes = document.querySelectorAll('[data-helium]');
    var best = null;
    var bestScore = 0;
    Array.prototype.forEach.call(nodes, function (node) {
      var helium = parseHeliumAttr(node.getAttribute('data-helium'));
      if (!helium) return;
      var score = [
        helium.h_category || helium.category_level_1,
        helium.h_subcategory || helium.category_level_2,
        helium.h_subcategory_type || helium.category_level_3
      ].filter(function (value) { return heliumText(value); }).length;
      if (score > bestScore) {
        best = helium;
        bestScore = score;
      }
    });
    return best;
  }

  function categoryScore(helium) {
    if (!helium) return 0;
    return [
      helium.h_category || helium.category_level_1,
      helium.h_subcategory || helium.category_level_2,
      helium.h_subcategory_type || helium.category_level_3
    ].filter(function (value) { return heliumText(value); }).length;
  }

  function collectionCategorySource() {
    var collection = page.collection || {};
    var fromPage = heliumText(collection.category_level_1) ? {
      h_category: collection.category_level_1,
      h_subcategory: collection.category_level_2,
      h_subcategory_type: collection.category_level_3
    } : null;
    var fromListing = listingHelium();
    if (categoryScore(fromListing) >= categoryScore(fromPage) && fromListing) return fromListing;
    return fromPage;
  }

  function viewCategoryFields() {
    var helium = categoryFromHelium(collectionCategorySource());
    var level1 = helium.category_level_1 || '';
    var level2 = helium.category_level_2 || '';
    var level3 = helium.category_level_3 || '';
    var levels = [level1, level2, level3].filter(Boolean);
    var name = level2 || level1 || '';
    var ids = levels.map(categorySlug);
    return defined({
      category_level_1: level1,
      category_level_2: level2,
      category_level_3: level3,
      category_name: name,
      category_id: name ? categorySlug(name) : '',
      categories_path: levels.length ? levels.join(' > ') : '',
      categories_ids: ids.length ? arrayValue(prefixCategoryIds(ids)) : ''
    });
  }

  function filterLabel(name) {
    var label = String(name || '').split('.').pop().replace(/^_+/, '').toLowerCase();
    if (label === 'vendor' || label.indexOf('brand') !== -1) return 'brand';
    if (label.indexOf('movement') !== -1) return 'movement';
    return label.replace(/[\s-]+/g, '_');
  }

  function decodeFilterValue(value) {
    var text = String(value || '').replace(/\+/g, ' ').trim();
    try { text = decodeURIComponent(text); } catch (error) {}
    return text.replace(/\s+/g, ' ').trim();
  }

  function categoryFilters() {
    var filters = [];
    var seen = {};
    function add(name, value) {
      var label = filterLabel(name);
      var text = decodeFilterValue(value);
      if (!label || !text) return;
      var entry = label + '=' + text;
      if (seen[entry]) return;
      seen[entry] = true;
      filters.push(entry);
    }
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      var match = key.match(/(?:^|\[)(?:refinementList|hierarchicalMenu|menu|numericMenu|toggle)\]\[([^\]]+)\]/) ||
        key.match(/^(?:refinementList|hierarchicalMenu|menu|numericMenu|toggle)\[([^\]]+)\]/);
      if (match) add(match[1], value);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.ais-current-refined-values--link[data-attribute]'), function (el) {
      add(el.getAttribute('data-attribute'), el.getAttribute('data-label') || el.getAttribute('data-value'));
    });
    return filters;
  }

  function categorySort() {
    var found = '';
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (key === 'sortBy' || key === 'sort_by' || /(?:^|\[)sortBy\]$/.test(key)) found = value;
    });
    if (!found) {
      var select = document.querySelector('.ais-sort-orders-container select, .ais-SortBy-select');
      if (select && select.value) found = select.value;
    }
    if (!found) found = (page.collection && page.collection.sort_by) || '';
    var text = decodeFilterValue(found);
    if (!text || /^https?:/i.test(text) || text.indexOf('/collections/') !== -1 || text.indexOf('/products/') !== -1) return '';
    if (/price[-_]desc$/.test(text) || text === 'price-descending') return 'price_high_to_low';
    if (/price[-_]asc$/.test(text) || text === 'price-ascending') return 'price_low_to_high';
    var match = text.match(/_([a-z0-9]+)_(asc|desc)$/i);
    if (match) {
      if (match[1] === 'price' && match[2].toLowerCase() === 'desc') return 'price_high_to_low';
      if (match[1] === 'price' && match[2].toLowerCase() === 'asc') return 'price_low_to_high';
      return match[1] + '_' + match[2].toLowerCase();
    }
    if (/products/i.test(text)) return 'relevance';
    return text.replace(/-/g, '_');
  }

  function categorySignature() {
    return categorySort() + '\n' + categoryFilters().join('\n');
  }

  function trackCategory() {
    if (page.page_type !== 'collection' || !page.collection) return;
    var algoliaOn = window.algoliaShopify &&
      window.algoliaShopify.config &&
      window.algoliaShopify.config.instant_search_enabled_on_collection;
    var hasCards = !!document.querySelector('.ais-product[data-id]');
    if (algoliaOn && !hasCards && !state.categoryKey) return;
    var signature = categorySignature();
    if (signature === state.categoryKey) return;
    state.categoryKey = signature;
    listingRows.skipCatalog = algoliaOn && !hasCards;
    var rows;
    try {
      rows = listingRows();
    } finally {
      listingRows.skipCatalog = false;
    }
    var filters = categoryFilters();
    track('view_category', Object.assign({
      os: os(),
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: page.source_type || 'web',
      domain: page.domain || '',
      language: page.language || '',
      local_currency: currency(),
      location: window.location.origin + window.location.pathname,
      listed_products: idList(rows.productIds),
      product_ids: idList(rows.productIds),
      variant_ids: idList(rows.variantIds),
      sku_ids: idList(rows.skuIds),
      shopify_parent_ids: idList(rows.parentIds),
      shopify_variant_ids: idList(rows.shopifyVariantIds),
      sort_by: categorySort(),
      filter_by: filters.length ? arrayValue(filters) : ''
    }, viewCategoryFields()));
  }

  function whenCategoryReady(done) {
    var algoliaOn = page.page_type === 'collection' &&
      window.algoliaShopify &&
      window.algoliaShopify.config &&
      window.algoliaShopify.config.instant_search_enabled_on_collection;
    if (!algoliaOn) {
      done();
      return;
    }
    if (document.querySelector('.ais-product[data-id]')) {
      window.setTimeout(done, 600);
      return;
    }
    var root = document.body;
    var finished = false;
    var observer = new MutationObserver(function () {
      if (document.querySelector('.ais-product[data-id]')) finish();
    });
    function finish() {
      if (finished) return;
      finished = true;
      observer.disconnect();
      window.setTimeout(done, 600);
    }
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(finish, 8000);
  }

  function watchCategoryRefinements() {
    if (page.page_type !== 'collection' || !page.collection) return;
    var timer = 0;
    function schedule() {
      window.clearTimeout(timer);
      timer = window.setTimeout(trackCategory, 800);
    }
    window.addEventListener('popstate', schedule);
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      if (!original || original.__exponeaCategory) return;
      var wrapped = function () {
        var before = window.location.pathname + window.location.search;
        var result = original.apply(history, arguments);
        if (window.location.pathname + window.location.search !== before) schedule();
        return result;
      };
      wrapped.__exponeaCategory = true;
      history[method] = wrapped;
    });
    document.addEventListener('change', function (event) {
      var el = event.target;
      if (!el || !el.closest) return;
      if (el.closest('.ais-sort-orders-container, .ais-SortBy, .ais-facets, .ais-facet, .filter-drawer')) schedule();
    }, true);
  }

  function device() {
    var ua = navigator.userAgent;
    if (/iPad|Tablet/i.test(ua)) return 'tablet';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile';
    return 'desktop';
  }

  function os() {
    var ua = navigator.userAgent;
    if (/Android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
    if (/Windows/i.test(ua)) return 'windows';
    if (/Macintosh|Mac OS X/i.test(ua)) return 'mac';
    if (/Linux/i.test(ua)) return 'linux';
    return '';
  }

  function browserName() {
    var ua = navigator.userAgent;
    if (/Edg\//.test(ua)) return 'Edge';
    if (/OPR\/|Opera/.test(ua)) return 'Opera';
    if (/Chrome\//.test(ua)) return 'Chrome';
    if (/Safari\//.test(ua)) return 'Safari';
    if (/Firefox\//.test(ua)) return 'Firefox';
    return 'Other';
  }

  function consentDevice() {
    var kind = device();
    if (kind === 'mobile') return 'Mobile';
    if (kind === 'tablet') return 'Tablet';
    return 'Other';
  }

  function consentOs() {
    var name = os();
    if (name === 'ios') return 'iOS';
    if (name === 'mac') return 'Mac';
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  function productHandle(el) {
    if (el && el.dataset && el.dataset.handle) return el.dataset.handle;
    var scope = (el && el.closest && el.closest('.card, .ais-InfiniteHits-item, .ais-hit, product-info, li')) || (el && el.parentElement) || document;
    var handleEl = scope.querySelector && scope.querySelector('[data-handle]');
    if (handleEl && handleEl.dataset.handle) return handleEl.dataset.handle;
    var link = scope.querySelector && scope.querySelector('a[href*="/products/"]');
    var href = (link && link.getAttribute('href')) || window.location.pathname;
    var match = String(href).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  var productCache = {};
  function loadProduct(handle) {
    if (!handle) return Promise.reject();
    if (!productCache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.json(); })
        .then(function (product) {
          return {
            id: product.id,
            title: product.title,
            vendor: product.vendor,
            type: product.type,
            tags: product.tags || [],
            handle: product.handle,
            options: product.options || [],
            variants: (product.variants || []).map(function (variant) {
              return {
                id: variant.id,
                sku: variant.sku,
                barcode: variant.barcode,
                price: variant.price,
                compare_at_price: variant.compare_at_price,
                available: variant.available,
                option1: variant.option1,
                option2: variant.option2,
                option3: variant.option3
              };
            })
          };
        });
    }
    return productCache[handle];
  }

  function itemLists(line) {
    var productId = line.product_id ? [String(line.product_id)] : [];
    var sku = line.sku_id ? [String(line.sku_id)] : [];
    var parent = line.shopify_parent_id ? [String(line.shopify_parent_id)] : [];
    var variant = line.shopify_variant_id ? [String(line.shopify_variant_id)] : [];
    var flags = listServiceFlags(line);
    return defined({
      product_ids: productId,
      product_list: productId.length ? [Object.assign({ product_id: productId[0], quantity: 1 }, flags)] : [],
      variant_ids: sku,
      variant_list: sku.length ? [Object.assign({ variant_id: sku[0], quantity: 1 }, flags)] : [],
      sku_ids: sku,
      sku_list: sku.length ? [Object.assign({ sku_id: sku[0], quantity: 1 }, flags)] : [],
      shopify_parent_ids: parent,
      shopify_parent_id_list: parent.length ? [Object.assign({ shopify_parent_id: parent[0], quantity: 1 }, flags)] : [],
      shopify_variant_ids: variant,
      shopify_variant_id_list: variant.length ? [Object.assign({ shopify_variant_id: variant[0], quantity: 1 }, flags)] : []
    });
  }

  function parseHeliumAttr(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch (decodeError) {
        return null;
      }
    }
  }

  function heliumFromElement(el) {
    if (!el || !el.closest) return null;
    var host = el.closest('.mswishlistbutton') || el;
    var parsed = parseHeliumAttr(host.getAttribute('data-helium'));
    if (parsed && (parsed.h_category || parsed.category_level_1)) return parsed;
    var scope = host.closest('.ais-InfiniteHits-item, .ais-hit, .card-wrapper, .card, product-info, li') || host.parentElement;
    var node = scope && scope.querySelector('[data-helium]');
    parsed = parseHeliumAttr(node && node.getAttribute('data-helium'));
    if (parsed && (parsed.h_category || parsed.category_level_1)) return parsed;
    return null;
  }

  function categoriesFromPage(productId) {
    var el = document.querySelector('.exponea-product');
    if (!el) return null;
    try {
      var product = JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
    if (!product || (productId && String(product.id) !== String(productId))) return null;
    return product.categories || null;
  }

  function wishlistPageType() {
    if (/wishlist/i.test(window.location.pathname + ' ' + window.location.search)) return 'wishlist';
    var type = pageType();
    return type === 'pdp' ? 'product' : type;
  }

  function trackWishlistProduct(product, variant, action, source) {
    variant = variant || {};
    fillWishlistProduct(product, variant);
    rememberWishlistProduct(product, variant);
    var key = String((product && (product.id || product.handle)) || (variant && variant.id) || 'wishlist') + ':' + action;
    var payload;
    try {
      var line = withLists(linePayload(product, variant), ['categories_path']);
      var categories = categoryFromHelium(product && product.categories);
      var buttonLevels = categoryFromHelium({
        h_category: product && product.category_level_1,
        h_subcategory: product && product.category_level_2,
        h_subcategory_type: product && product.category_level_3,
        h_colour_primary_value: product && product.color
      });
      var productLevels = categories.category_level_1 ? categories : buttonLevels;
      if (productLevels.category_level_1 || productLevels.category_level_2 || productLevels.category_level_3) {
        line.category_level_1 = productLevels.category_level_1 || '';
        line.category_level_2 = productLevels.category_level_2 || '';
        line.category_level_3 = productLevels.category_level_3 || '';
        if (!line.categories_path && productLevels.categories_path) line.categories_path = asList(productLevels.categories_path);
        if (!line.category_id && productLevels.category_id) line.category_id = productLevels.category_id;
        if ((!line.categories_ids || (Array.isArray(line.categories_ids) && !line.categories_ids.length)) && productLevels.categories_ids) {
          line.categories_ids = productLevels.categories_ids;
        }
      }
      if (line.categories_ids) line.categories_ids = arrayValue(line.categories_ids);
      line.tags = tagsValue(line.tags);
      syncPrices(line, line.price, line.original_price);
      var price = money(variant.price);
      payload = Object.assign(line, {
        action: action,
        button_type: source || buttonType(),
        button_copy: action === 'remove' ? 'Remove from wishlist' : 'Add to wishlist',
        page_type: wishlistPageType(),
        total_quantity: 1,
        total_price: price,
        total_price_local_currency: price
      }, taxFields(price));
      if (action === 'remove') {
        payload = restoreWishlistLineSnapshot(payload, product, variant);
        Object.assign(payload, wishlistLiveSelection(product, variant, payload));
        payload.action = 'remove';
        payload.button_copy = 'Remove from wishlist';
        payload.button_type = source || buttonType() || payload.button_type;
        payload.page_type = wishlistPageType();
      }
    } catch (error) {
      payload = Object.assign({
        action: action,
        shopify_parent_id: String((product && product.id) || ''),
        shopify_variant_id: String((variant && variant.id) || ''),
        title: (product && product.title) || '',
        button_copy: action === 'remove' ? 'Remove from wishlist' : 'Add to wishlist',
        button_type: source || buttonType(),
        page_type: wishlistPageType(),
        total_quantity: 1,
        discount_value: 0,
        discount_percentage: 0
      }, action === 'remove' ? restoreWishlistLineSnapshot({}, product, variant) : {});
      if (action === 'remove') {
        Object.assign(payload, wishlistLiveSelection(product, variant, payload));
        payload.action = 'remove';
        payload.button_copy = 'Remove from wishlist';
      }
    }
    publishWishlist(key, payload, {}, product, variant, action);
  }

  var lastWishlistButton = null;
  var WISHLIST_SELECTOR = '.mswishlistbutton, .wishlistDiv, .wishlist-button, .wk-button, .wk-add-product, wishlist-button-collection, wishlist-button-product, wishlist-button';

  function classText(node) {
    if (!node || node.nodeType !== 1) return '';
    if (typeof node.className === 'string') return node.className;
    return (node.className && node.className.baseVal) || '';
  }

  function isWishlistElement(node) {
    if (!node || node.nodeType !== 1) return false;
    var tag = String(node.tagName || '').toLowerCase();
    if (tag.indexOf('wishlist') !== -1) return true;
    if (node.matches) {
      try {
        if (node.matches(WISHLIST_SELECTOR)) return true;
      } catch (error) {}
    }
    return /mswishlistbutton|wishlistDiv|wishlist-button|wk-button/.test(classText(node));
  }

  function productFromPage(productId, handle) {
    var nodes = document.querySelectorAll('.exponea-product');
    var index;
    var only = null;
    for (index = 0; index < nodes.length; index += 1) {
      try {
        var product = JSON.parse(nodes[index].textContent);
      } catch (error) {
        continue;
      }
      if (!product) continue;
      if (nodes.length === 1) only = product;
      if (productId && String(product.id) === String(productId)) return product;
      if (handle && product.handle === handle) return product;
    }
    if (only && page.page_type === 'product') return only;
    return null;
  }

  function wishlistPath(event) {
    var nodes = [];
    if (event.composedPath) {
      try { nodes = event.composedPath(); } catch (error) {}
    }
    var node = event.target;
    while (node) {
      nodes.push(node);
      node = node.parentNode || node.host || null;
    }
    return nodes;
  }

  function isWishlistButton(node) {
    if (!node || node.nodeType !== 1) return false;
    var id = String(node.id || '');
    if (id === 'mswishlistbutton' || id.indexOf('mswishlistbutton') === 0) return true;
    return /(^|\s)mswishlistbutton(\s|$)/.test(classText(node));
  }

  function wishlistHost(event) {
    var nodes = wishlistPath(event);
    var index;
    var node;
    for (index = 0; index < nodes.length; index += 1) {
      node = nodes[index];
      if (!node || node.nodeType !== 1) continue;
      if (node.closest) {
        try {
          var found = node.closest('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]');
          if (found) return found;
        } catch (error) {}
      }
      if (isWishlistButton(node)) return node;
    }
    node = event.target;
    while (node && node !== document) {
      if (isWishlistButton(node)) return node;
      node = node.parentNode || node.host || null;
    }
    return null;
  }

  function wishlistMarked(button) {
    if (!button || !button.classList) return false;
    if (button.getAttribute('data-wl-active') === '1') return true;
    if (button.classList.contains('wk-selected') || button.classList.contains('added') || button.classList.contains('in-wishlist') || button.getAttribute('aria-pressed') === 'true') return true;
    return !!(button.querySelector && button.querySelector('.wk-button.wk-selected, .wk-selected, .in-wishlist'));
  }

  function buttonHandle(button) {
    if (!button) return '';
    if (button.getAttribute) {
      var handle = button.getAttribute('data-handle') || button.getAttribute('data-product-handle');
      if (handle) return handle;
    }
    return productHandle(button);
  }

  function listingProduct(button) {
    if (!button || !button.closest) return null;
    var scope = (button.closest && button.closest('.ais-InfiniteHits-item, .ais-hit, .card-wrapper, .card, li, product-info')) || button.parentElement;
    var card = scope && scope.querySelector && scope.querySelector('.ais-product');
    if (!card || !card.dataset) return null;
    return {
      id: card.dataset.id || (button.dataset && button.dataset.product) || '',
      title: (button.dataset && button.dataset.productName) || '',
      handle: card.dataset.handle || (button.dataset && button.dataset.handle) || '',
      options: [],
      variants: [{
        id: Number(card.dataset.variantId || (button.dataset && button.dataset.variant)) || '',
        sku: card.dataset.sku || '',
        barcode: card.dataset.barcode || '',
        price: 0,
        inventory: button && button.dataset && button.dataset.inventory !== '' && button.dataset.inventory != null ? Number(button.dataset.inventory) : null
      }]
    };
  }

  function wishlistVariant(product, variantId) {
    var variants = (product && product.variants) || [];
    var match = variants.find(function (item) { return String(item.id) === String(variantId); });
    return match || variants[0] || { id: variantId || '', sku: '', barcode: '', price: 0 };
  }

  function buttonAttr(button, name) {
    if (!button || !button.getAttribute) return '';
    var value = button.getAttribute(name);
    return value == null ? '' : String(value).trim();
  }

  function applyWishlistDetails(product, button) {
    if (!product) return product;
    var vendor = buttonAttr(button, 'data-vendor');
    var type = buttonAttr(button, 'data-product-type');
    var color = buttonAttr(button, 'data-color');
    var size = buttonAttr(button, 'data-size');
    var tags = tagList(buttonAttr(button, 'data-tags'));
    var level1 = buttonAttr(button, 'data-category-1');
    var level2 = buttonAttr(button, 'data-category-2');
    var level3 = buttonAttr(button, 'data-category-3');
    var engravingAttr = buttonAttr(button, 'data-engraving');
    var giftWrapAttr = buttonAttr(button, 'data-gift-wrapping');
    var card = button && button.closest ? button.closest('[data-cat-level-1]') : null;
    if (!level1 && card) level1 = buttonAttr(card, 'data-cat-level-1');
    if (!level2 && card) level2 = buttonAttr(card, 'data-cat-level-2');
    if (!level3 && card) level3 = buttonAttr(card, 'data-cat-level-3');
    if (level1) product.category_level_1 = level1;
    if (level2) product.category_level_2 = level2;
    if (level3) product.category_level_3 = level3;
    if (!product.vendor && vendor) product.vendor = vendor;
    if (!product.type && type) product.type = type;
    if (!product.color && color) product.color = color;
    if (!product.size && size) product.size = size;
    if ((!product.tags || !product.tags.length) && tags.length) product.tags = tags;
    // data-engraving on cards is metafield capability, not customer selection.
    if (engravingAttr !== '') product.item_engraving_flag = boolFlag(engravingAttr);
    if (giftWrapAttr !== '') product.item_gift_wrapping_flag = boolFlag(giftWrapAttr);
    var current = categoryFromHelium(product.categories);
    if (!current.category_level_1 && !current.category_level_2 && !current.category_level_3 && (level1 || level2 || level3)) {
      product.categories = Object.assign({}, product.categories || {}, {
        h_category: level1,
        h_subcategory: level2,
        h_subcategory_type: level3,
        h_colour_primary_value: color || (product.categories && product.categories.h_colour_primary_value) || ''
      });
    }
    return product;
  }

  function emitWishlist(button, action, productId, variantId) {
    productId = productId || (button && button.getAttribute && button.getAttribute('data-product')) || '';
    variantId = variantId || (button && button.getAttribute && button.getAttribute('data-variant')) || '';
    if (!wishlistGestureAllows(productId, variantId, action)) return;
    var handle = buttonHandle(button);
    var helium = heliumFromElement(button);
    var product = productFromPage(productId, handle) || listingProduct(button) || {
      id: productId,
      title: (button && button.getAttribute && button.getAttribute('data-product-name')) || '',
      handle: handle,
      vendor: (button && button.getAttribute && button.getAttribute('data-vendor')) || '',
      options: [],
      variants: []
    };
    if (helium) product.categories = helium;
    applyWishlistDetails(product, button);
    if (!product.id) product.id = productId;
    if (!product.title) product.title = (button && button.getAttribute && button.getAttribute('data-product-name')) || '';
    var variant = wishlistVariant(product, variantId);
    applyButtonStock(variant, button);
    if (button && button.getAttribute) {
      if (!variant.barcode) variant.barcode = button.getAttribute('data-barcode') || '';
      if (!variant.sku) variant.sku = button.getAttribute('data-sku') || '';
      if (!variant.id) variant.id = variantId || button.getAttribute('data-variant') || '';
      if (!variant.price) {
        var listedPrice = Number(button.getAttribute('data-price'));
        if (listedPrice) variant.price = Math.round(listedPrice * 100);
      }
      if (!variant.compare_at_price) {
        var listedCompare = Number(button.getAttribute('data-compare-at-price'));
        if (listedCompare) variant.compare_at_price = Math.round(listedCompare * 100);
      }
    }
    try {
      trackWishlistProduct(product, variant, action, buttonType());
    } catch (error) {
      track('wishlist', withCategoryIdPrefix(withStock(Object.assign({
        action: action,
        shopify_parent_id: String(productId),
        shopify_variant_id: String(variantId),
        title: product.title || '',
        button_copy: action === 'remove' ? 'Remove from wishlist' : 'Add to wishlist',
        button_type: buttonType(),
        page_type: wishlistPageType(),
        total_quantity: 1,
        discount_value: 0,
        discount_percentage: 0
      }, action === 'remove' ? restoreWishlistLineSnapshot({}, product, { id: variantId }) : selectionFlags({ usePage: true })), variant)));
    }
  }

  function trackWishlistClick(button, forcedAction) {
    if (!button) return;
    var productId = (button.getAttribute && button.getAttribute('data-product')) || '';
    var variantId = (button.getAttribute && button.getAttribute('data-variant')) || '';
    var action = forcedAction || (wishlistMarked(button) ? 'remove' : 'add');
    emitWishlist(button, action, productId, variantId);
  }

  function trackWishlistApi(call, action) {
    action = action || 'add';
    call = call || {};
    if (!call.productId && pendingWishlistUi && pendingWishlistUi.productId) {
      call.productId = pendingWishlistUi.productId;
      call.variantId = call.variantId || pendingWishlistUi.variantId || '';
    }
    // Cart "Move to Wishlist" — reuse the cart line so gift_wrapping/engraving selection carry over.
    if (
      action === 'add' &&
      pendingWishlistMove &&
      (
        (call.variantId && String(pendingWishlistMove.variantId) === String(call.variantId)) ||
        (!call.variantId && pendingWishlistMove.item)
      )
    ) {
      trackMovedWishlist({
        productId: call.productId || '',
        variantId: call.variantId || pendingWishlistMove.variantId || ''
      });
      return;
    }
    var button = lastWishlistButton;
    var buttons = document.querySelectorAll('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]');
    var index;
    if (call.productId) {
      for (index = 0; index < buttons.length; index += 1) {
        if (String(buttons[index].getAttribute('data-product') || '') === String(call.productId)) {
          button = buttons[index];
          break;
        }
      }
    }
    if (!button && call.variantId) {
      for (index = 0; index < buttons.length; index += 1) {
        if (String(buttons[index].getAttribute('data-variant') || '') === String(call.variantId)) {
          button = buttons[index];
          break;
        }
      }
    }
    if (!button && page.page_type === 'product' && buttons.length) button = document.getElementById('mswishlistbutton') || buttons[0];
    if (!button && !call.productId && !call.variantId) return;
    lastWishlistButton = button || lastWishlistButton;
    // Same-action duplicates are handled by wishlistOnce; opposite actions must still fire
    // (e.g. remove then re-add the same product).
    emitWishlist(button, action, call.productId, call.variantId);
  }

  function trackWishlistEvent(event) {
    try {
      var data = (event && (event.data || event.detail)) || {};
      var product = data.product || null;
      var name = String((event && event.name) || data.action || data.name || '');
      var action = /remove|delete/i.test(name) ? 'remove' : 'add';
      if (!product || (!product.id && !product.handle)) {
        if (lastWishlistButton) trackWishlistClick(lastWishlistButton, action);
        return;
      }
      var variant = data.variant || (product.variants && product.variants[0]) || {
        id: data.variantId || data.variant_id || '',
        sku: data.sku || product.sku || '',
        barcode: data.barcode || product.barcode || '',
        price: data.price || product.price || 0,
        compare_at_price: data.compare_at_price || product.compare_at_price || 0
      };
      var button = document.querySelector('.mswishlistbutton[data-product="' + product.id + '"]') || lastWishlistButton;
      if (button && button.getAttribute) {
        if (!variant.price) {
          var listedPrice = Number(button.getAttribute('data-price'));
          if (listedPrice) variant.price = Math.round(listedPrice * 100);
        }
        if (!variant.compare_at_price) {
          var listedCompare = Number(button.getAttribute('data-compare-at-price'));
          if (listedCompare) variant.compare_at_price = Math.round(listedCompare * 100);
        }
      }
      var trackedProduct = {
        id: product.id,
        title: product.title,
        vendor: product.vendor,
        type: product.type || product.product_type,
        tags: product.tags || [],
        color: product.color,
        size: product.size,
        handle: product.handle,
        options: (product.options || []).map(function (option) { return option.name || option; }),
        categories: heliumFromElement(button) || categoriesFromPage(product.id) || product.categories
      };
      applyWishlistDetails(trackedProduct, button);
      trackWishlistProduct(
        trackedProduct,
        variant,
        action,
        buttonType()
      );
    } catch (error) {
      if (lastWishlistButton) trackWishlistClick(lastWishlistButton, 'add');
    }
  }

  function profileUpdate(customer) {
    if (!customer || !customer.email || !window.exponea) return;
    var ids = { email_id: customer.email };
    if (customer.id) {
      ids.shopify_id = String(customer.id);
      ids.registered = String(customer.id);
    }
    if (typeof window.exponea.identify === 'function') window.exponea.identify(ids);
    if (typeof window.exponea.update !== 'function') return;
    window.exponea.update(defined({
      email: customer.email,
      first_name: customer.first_name,
      last_name: customer.last_name,
      phone: customer.phone,
      city: customer.city,
      state: customer.state,
      country: customer.country,
      language: page.language,
      locale: page.locale,
      gender: customer.gender,
      birth_date: birthDate(customer.birth_date),
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: page.source_type || 'web',
      domain: page.domain,
      page_link: window.location.href,
      _accepts_marketing: typeof customer.accepts_marketing === 'boolean' ? customer.accepts_marketing : undefined,
      _tags: customer.tags && customer.tags.length ? customer.tags : undefined
    }));
  }

  function signupRecent(customer) {
    if (!customer || !customer.created_at) return false;
    var created = Number(customer.created_at);
    if (!created) return false;
    return Math.abs(Math.floor(Date.now() / 1000) - created) < 600;
  }

  function justRegistered(customer) {
    if (!customer || !customer.email || !customer.created_at) return false;
    if (document.referrer.indexOf('/account/register') === -1) return false;
    var created = Number(customer.created_at);
    if (!created) return false;
    try {
      if (window.sessionStorage.getItem('exponea_signup_tracked') === customer.email) return false;
    } catch (error) {}
    return Math.abs(Math.floor(Date.now() / 1000) - created) < 600;
  }

  function onLoginPage() {
    return page.page_type === 'login' || /\/account\/login\/?$/.test(window.location.pathname);
  }

  function markLoginSubmit() {
    try {
      window.sessionStorage.setItem('exponea_login', '1');
      window.sessionStorage.removeItem('exponea_login_tracked');
    } catch (error) {}
  }

  function watchLoginForm() {
    var form = document.getElementById('customer_login');
    if (!form || form.dataset.exponeaLogin) return;
    form.dataset.exponeaLogin = '1';
    form.addEventListener('submit', markLoginSubmit, true);
  }

  function trackSuccessfulLogin() {
    if (state.loginTracked || onLoginPage()) return;
    var customer = page.customer || {};
    if (!customer.email) return;
    if (document.referrer.indexOf('/account/register') !== -1) return;
    var pending = false;
    var signup = false;
    try {
      pending = window.sessionStorage.getItem('exponea_login') === '1';
      signup = window.sessionStorage.getItem('exponea_signup') === '1';
    } catch (error) {}
    if (!pending || signup) return;
    try {
      if (window.sessionStorage.getItem('exponea_login_tracked') === customer.email) {
        window.sessionStorage.removeItem('exponea_login');
        return;
      }
    } catch (error) {}
    try { window.sessionStorage.removeItem('exponea_login'); } catch (error) {}
    trackLogin();
  }

  function trackLogin() {
    if (state.loginTracked) return;
    var customer = page.customer || {};
    if (!customer.email) return;
    state.loginTracked = true;
    try { window.sessionStorage.setItem('exponea_login_tracked', customer.email); } catch (error) {}
    track('login', {
      status: 'success',
      method: 'email_password',
      timestamp: Math.floor(Date.now() / 1000),
      location: 'login',
      domain: page.domain,
      os: os(),
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: 'web'
    });
  }

  function onAccountPage() {
    return page.page_type === 'account' || /\/account\/?$/.test(window.location.pathname);
  }

  function trackSignupPage() {
    if (state.signupTracked) return;
    var customer = page.customer || {};
    if (onRegisterPage() && !customer.email) return;
    if (!customer.email) return;
    var pending = false;
    var typed = {};
    var fromRegister = document.referrer.indexOf('/account/register') !== -1;
    try {
      pending = window.sessionStorage.getItem('exponea_signup') === '1';
      typed = JSON.parse(window.sessionStorage.getItem('exponea_auth_fields') || '{}');
    } catch (error) {}
    if (typed.email && String(typed.email).toLowerCase() !== String(customer.email).toLowerCase() && !(fromRegister && signupRecent(customer))) return;
    if (!pending && !(fromRegister && signupRecent(customer))) return;
    try {
      if (window.sessionStorage.getItem('exponea_signup_account') === customer.email) return;
    } catch (error) {}
    state.signupTracked = true;
    try {
      window.sessionStorage.setItem('exponea_signup_account', customer.email);
      window.sessionStorage.removeItem('exponea_signup');
      window.sessionStorage.removeItem('exponea_login');
      window.sessionStorage.removeItem('exponea_auth_fields');
    } catch (error) {}
    if (window.exponea && typeof window.exponea.identify === 'function') {
      var ids = { email_id: customer.email };
      if (customer.id) {
        ids.shopify_id = String(customer.id);
        ids.registered = String(customer.id);
      }
      window.exponea.identify(ids);
    }
    trackSignup(customer, typed);
  }

  function syncCustomer() {
    var customer = page.customer;
    var profile = false;
    try {
      profile = window.sessionStorage.getItem('exponea_profile') === '1';
      if (profile) window.sessionStorage.removeItem('exponea_profile');
    } catch (error) {}
    var consentPending = false;
    try {
      consentPending = window.sessionStorage.getItem('exponea_consent_pending') === '1' || !!(customer && customer.updates_consent != null && customer.updates_consent !== '' && customer.updates_consent !== false && signupRecent(customer));
    } catch (error) {}
    if (!customer || !customer.email || (!profile && !consentPending)) return;
    if (!state.signupTracked) profileUpdate(customer);
    try { window.sessionStorage.removeItem('exponea_auth_fields'); } catch (error) {}
    flushConsent();
  }

  function authKind(form) {
    if (!form) return '';
    var action = form.getAttribute('action') || '';
    if (form.id === 'create_customer') return 'signup';
    if (form.id === 'customer_login') return 'login';
    if (form.querySelector('[name="customer[first_name]"]') && /\/account\/?($|\?)/.test(action)) return 'signup';
    if (/\/account\/login/.test(action)) return 'login';
    return '';
  }

  function fieldText(value) {
    if (value == null || value === '') return '';
    if (typeof value.format === 'function') {
      try { return value.format('YYYY-MM-DD'); } catch (error) {}
    }
    if (Array.isArray(value)) return fieldText(value[0]);
    if (typeof value === 'object') return fieldText(value.value || value.label || value.name || '');
    return heliumText(value);
  }

  function birthDate(value) {
    var text = fieldText(value);
    if (!text) return '';
    var iso = text.match(/\d{4}-\d{2}-\d{2}/);
    if (iso) return iso[0];
    var dmy = text.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (dmy) return dmy[3] + '-' + ('0' + dmy[2]).slice(-2) + '-' + ('0' + dmy[1]).slice(-2);
    var parsed = new Date(text);
    if (isNaN(parsed.getTime())) return text;
    var month = parsed.getMonth() + 1;
    var day = parsed.getDate();
    return parsed.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
  }

  function phoneNumber(value) {
    var text = fieldText(value).replace(/[^\d+]/g, '');
    if (text.charAt(0) === '+') text = text.slice(1);
    return text;
  }

  function trackSignup(customer, typed) {
    typed = typed || {};
    customer = customer || {};
    if (!window.exponea || typeof window.exponea.track !== 'function') return false;
    var email = fieldText(customer.email || typed.email);
    try {
      if (window.sessionStorage.getItem('exponea_md_signup_done') === '1') return false;
      if (email && window.localStorage.getItem('afwj_signup_sent:' + email.toLowerCase()) === '1') return false;
    } catch (error) {}
    var customerId = customer.id ? String(customer.id) : '';
    var phone = phoneNumber(typed.phone || customer.phone);
    var payload = {
      birth_date: birthDate(typed.birth_date) || birthDate(customer.birth_date),
      browser: browserName(),
      category: 'register',
      device: consentDevice(),
      domain: page.domain || window.location.hostname.replace(/^www\./, ''),
      email: email,
      first_name: fieldText(typed.first_name || customer.first_name),
      gender: fieldText(typed.gender) || genderFromTitle(customer.gender) || fieldText(customer.gender),
      last_name: fieldText(typed.last_name || customer.last_name),
      locale: page.locale || 'en_ae',
      location: 'register',
      os: consentOs(),
      phone: phone ? '+' + phone : '',
      source_name: page.source_name || 'AFWJ UAE Website',
      source_type: 'web',
      status: 'success',
      timestamp: Date.now()
    };
    if (customerId) payload.customer_ids = { registered: customerId };
    try {
      if (email) window.localStorage.setItem('afwj_signup_sent:' + email.toLowerCase(), '1');
    } catch (error) {}
    window.exponea.track('signup', defined(payload));
    return true;
  }

  function watchCreateCustomer() {
    var form = document.getElementById('create_customer');
    if (!form || form.dataset.exponeaSignupWatch) return;
    form.dataset.exponeaSignupWatch = '1';
    function onHeliumSuccess(event) {
      try { onHeliumSignup(event); } catch (error) {}
    }
    form.addEventListener('cf:form_submitted', onHeliumSuccess);
    form.addEventListener('cf:customer_saved', onHeliumSuccess);
  }

  function rememberAuth(form, kind) {
    if (kind === 'signup') {
      rememberCfSignup({}, form, false);
      try { window.sessionStorage.removeItem('exponea_login'); } catch (error) {}
      return;
    }
    if (!form || form.id !== 'customer_login') return;
    var valueOf = function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input && input.value ? input.value.trim() : '';
    };
    window.sessionStorage.setItem('exponea_login', '1');
    if (kind === 'login') window.sessionStorage.removeItem('exponea_login_tracked');
    window.sessionStorage.setItem('exponea_auth_fields', JSON.stringify({
      email: valueOf('customer[email]'),
      first_name: valueOf('customer[first_name]'),
      last_name: valueOf('customer[last_name]'),
      phone: valueOf('customer[phone]'),
      gender: fieldText(valueOf('newsletter_preferences')),
      birth_date: birthDate(valueOf('enter_your_birthday'))
    }));
  }

  var SIGNUP_KEYS = ['first_name', 'last_name', 'email', 'phone', 'phone_number', 'mobile_number', 'title', 'newsletter_preferences', 'gender', 'enter_your_birthday', 'birth_date', 'birthday', 'i_agree_to_receive_updates'];

  function readHeliumForm(form) {
    var data = {};
    if (!form) return data;
    if (form.cfForm && typeof form.cfForm.getFieldValue === 'function') {
      SIGNUP_KEYS.forEach(function (key) {
        try {
          var value = form.cfForm.getFieldValue(key);
          if (value != null && value !== '') data[key] = value;
        } catch (error) {}
      });
    }
    if (!form.querySelectorAll) return data;
    Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (input) {
      var key = input.getAttribute('data-cf-column-key') || input.getAttribute('data-cf-column') || input.name || '';
      key = key.replace(/^customer\[|\]$/g, '');
      if (!key || input.type === 'password' || (data[key] != null && data[key] !== '' && input.type !== 'checkbox')) return;
      if (input.type === 'radio') {
        if (input.checked) data[key] = input.value;
        return;
      }
      if (input.type === 'checkbox') {
        data[key] = input.checked ? (input.value && input.value !== 'on' ? input.value : true) : false;
        return;
      }
      if (input.value) data[key] = input.value;
    });
    return data;
  }

  function rememberCfSignup(data, form, ready) {
    data = Object.assign(readHeliumForm(form), data || {});
    if (Array.isArray(data.fields)) {
      data.fields.forEach(function (field) {
        if (!field) return;
        var key = field.key || field.name || field.column || field.columnKey;
        if (key && data[key] == null) data[key] = field.value;
      });
    }
    function pick() {
      var names = arguments;
      var index;
      for (index = 0; index < names.length; index += 1) {
        if (data[names[index]] != null && data[names[index]] !== '') return data[names[index]];
      }
      return '';
    }
    function keep(value, fallback) {
      var text = fieldText(value);
      return text || fieldText(fallback);
    }
    var previous = {};
    try { previous = JSON.parse(window.sessionStorage.getItem('exponea_auth_fields') || '{}'); } catch (error) {}
    var typed = heliumSignupValues(form);
    var fields = {
      email: keep(typed.email || pick('email', 'customer_email'), previous.email),
      first_name: keep(typed.first_name || pick('first_name'), previous.first_name),
      last_name: keep(typed.last_name || pick('last_name'), previous.last_name),
      phone: keep(typed.phone || phoneNumber(pick('mobile_number', 'phone', 'phone_number')), previous.phone),
      gender: keep(typed.gender || genderFromTitle(pick('title', 'gender')), previous.gender),
      birth_date: keep(typed.birth_date || birthDate(pick('enter_your_birthday', 'birth_date', 'birthday')), previous.birth_date)
    };
    if (ready) {
      window.sessionStorage.setItem('exponea_signup', '1');
      window.sessionStorage.removeItem('exponea_signup_account');
    }
    window.sessionStorage.removeItem('exponea_login');
    window.sessionStorage.removeItem('exponea_signup_tracked');
    window.sessionStorage.setItem('exponea_auth_fields', JSON.stringify(fields));
    try {
      if (!ready || window.sessionStorage.getItem('exponea_consent_pending') !== '1') queueHeliumConsent(data, form, fields);
    } catch (error) {}
  }

  function consentChannels(value) {
    var items = [];
    if (Array.isArray(value)) items = value;
    else if (typeof value === 'string' && value.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(value);
        items = Array.isArray(parsed) ? parsed : [value];
      } catch (error) {
        items = [value];
      }
    } else if (value != null && value !== '') items = [value];
    var categories = [];
    items.forEach(function (item) {
      var text = fieldText(item).toLowerCase();
      var matched = false;
      ['whatsapp', 'sms', 'push', 'email'].forEach(function (name) {
        if (text.indexOf(name) === -1 || categories.indexOf(name) !== -1) return;
        categories.push(name);
        matched = true;
      });
      if (matched) return;
      var plain = text.trim();
      if (!plain || /^(true|false|yes|no|grant|reject|1|0|on)$/.test(plain)) return;
      plain = plain.replace(/\s+/g, '_');
      if (categories.indexOf(plain) === -1) categories.push(plain);
    });
    return categories;
  }

  function consentAccepted(value, input) {
    if (value === false || value === 'false' || value === 'no' || value === 'reject' || value === 0 || value === '0') return false;
    if (input && input.type === 'checkbox') return !!input.checked;
    if (value === true || value === 'true' || value === 'yes' || value === 'grant' || value === 1 || value === '1') return true;
    return consentChannels(value).length > 0;
  }

  function consentLabel(form) {
    if (!form || !form.querySelectorAll) return '';
    var nodes = form.querySelectorAll('label, .cf-field-label, .cf-checkbox');
    var index;
    for (index = 0; index < nodes.length; index += 1) {
      var text = (nodes[index].textContent || '').replace(/\s+/g, ' ').trim();
      if (/agree to receive/i.test(text)) return text;
    }
    return '';
  }

  function heliumConsentInputs(form) {
    var found = [];
    var seen = {};
    function add(input) {
      if (!input || seen[input.id || input.value]) return;
      seen[input.id || input.value] = true;
      found.push(input);
    }
    function walk(root) {
      if (!root || !root.querySelectorAll) return;
      Array.prototype.forEach.call(root.querySelectorAll('input[name="i_agree_to_receive_updates"], input[data-cf-column-key="i_agree_to_receive_updates"]'), add);
      Array.prototype.forEach.call(root.querySelectorAll('*'), function (node) {
        if (node.shadowRoot) walk(node.shadowRoot);
      });
    }
    walk(form || document);
    if (!found.length) walk(document);
    ['value0-395281option0', 'value1-395281option1', 'value2-395281option2'].forEach(function (id) {
      add(document.getElementById(id));
    });
    return found;
  }

  function consentCategory(input) {
    var value = fieldText(input && input.value).toLowerCase();
    if (value.indexOf('whatsapp') !== -1) return 'whatsapp';
    if (value.indexOf('sms') !== -1) return 'sms';
    if (value.indexOf('email') !== -1 || value.indexOf('newsletter') !== -1) return 'email';
    return '';
  }

  function consentChoiceMessage(input) {
    var legend = input && input.closest && input.closest('fieldset') && input.closest('fieldset').querySelector('legend');
    var legendText = legend ? (legend.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (legendText) return legendText;
    var labelId = input && input.getAttribute('aria-labelledby');
    var label = labelId && document.getElementById(labelId);
    var choice = label ? (label.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return choice || consentLabel(input && input.closest && input.closest('form'));
  }

  function heliumConsentChoices(form) {
    var choices = [];
    var seen = {};
    heliumConsentInputs(form).forEach(function (input) {
      var category = consentCategory(input);
      if (!category || seen[category]) return;
      seen[category] = true;
      choices.push({
        category: category,
        accepted: !!input.checked,
        message: consentChoiceMessage(input),
        checkbox_id: input.id || ''
      });
    });
    return choices;
  }

  function queueHeliumConsent(data, form, fields) {
    var choices = heliumConsentChoices(form);
    if (!choices.length) return;
    try {
      window.sessionStorage.setItem('exponea_consent_pending', '1');
      window.sessionStorage.setItem('exponea_consent_context', JSON.stringify({
        message: choices[0].message || consentLabel(form),
        email: (fields && fields.email) || '',
        phone: (fields && fields.phone) || '',
        location: window.location.href,
        choices: choices
      }));
    } catch (error) {}
  }

  function flushConsent() {
    var customer = page.customer;
    if (!customer || !customer.email) return;
    try {
      if (window.sessionStorage.getItem('exponea_md_signup_done') === '1') return;
    } catch (error) {}
    var pending = false;
    var context = {};
    try {
      pending = window.sessionStorage.getItem('exponea_consent_pending') === '1';
      context = JSON.parse(window.sessionStorage.getItem('exponea_consent_context') || '{}') || {};
    } catch (error) {}
    var choices = context.choices || [];
    if (!choices.length && (pending || justRegistered(customer) || (signupRecent(customer) && customer.updates_consent))) {
      consentChannels(customer.updates_consent).forEach(function (category) {
        choices.push({
          category: category,
          accepted: true,
          message: context.message || ''
        });
      });
    }
    if (!pending && !choices.length) return;
    if (!choices.length) {
      if (!signupRecent(customer)) {
        try {
          window.sessionStorage.removeItem('exponea_consent_pending');
          window.sessionStorage.removeItem('exponea_consent_context');
        } catch (error) {}
      }
      return;
    }
    var marker = customer.email + '|' + choices.map(function (choice) {
      return choice.category + ':' + (choice.accepted ? 'grant' : 'reject');
    }).join(',');
    try {
      if (window.sessionStorage.getItem('exponea_consent_tracked') === marker) {
        window.sessionStorage.removeItem('exponea_consent_pending');
        return;
      }
    } catch (error) {}
    var location = context.location || '';
    if (!location && document.referrer.indexOf('/account/register') !== -1) location = document.referrer;
    choices.forEach(function (choice) {
      trackConsentChoice({
        category: choice.category,
        accepted: choice.accepted !== false,
        message: choice.message || context.message || '',
        location: location
      }, {
        email: customer.email,
        phone: phoneNumber(customer.phone || context.phone)
      });
    });
    try {
      window.sessionStorage.setItem('exponea_consent_tracked', marker);
      window.sessionStorage.removeItem('exponea_consent_pending');
      window.sessionStorage.removeItem('exponea_consent_context');
    } catch (error) {}
  }

  function heliumSignupForm(event) {
    var named = document.getElementById('create_customer');
    var target = event && event.target;
    if (target && target.id === 'create_customer') return target;
    if (target && target.closest) {
      var form = target.closest('#create_customer');
      if (form) return form;
      form = target.closest('form') || (target.matches && target.matches('form') ? target : null);
      if (form) return form;
    }
    return named || document.querySelector('form[data-cf-form="X1tQn4"]');
  }

  function isSignupForm(event) {
    var form = heliumSignupForm(event);
    if (form && form.id === 'create_customer') return true;
    var detail = (event && event.detail) || {};
    var formId = detail.formId || (form && form.getAttribute('data-cf-form')) || '';
    if (formId === 'X1tQn4') return true;
    if (page.page_type === 'register' || /\/account\/register/.test(window.location.pathname)) return !!form;
    return false;
  }

  function onRegisterPage() {
    return page.page_type === 'register' || /\/account\/register\/?$/.test(window.location.pathname);
  }

  function fieldById(id) {
    var el = document.getElementById(id);
    return el && el.value ? String(el.value).trim() : '';
  }

  function callingCode(form) {
    var select = form && form.querySelector && form.querySelector('.cf-phone-field .cf-country-picker select');
    var option = select && select.options[select.selectedIndex];
    var match = option && String(option.textContent || '').match(/\+(\d+)/);
    return match ? match[1] : '';
  }

  function fullPhone(value, form) {
    var digits = phoneNumber(value);
    var code = callingCode(form);
    if (!digits) return '';
    if (code && digits.indexOf(code) !== 0) return code + digits;
    return digits;
  }

  function genderFromTitle(value) {
    var text = fieldText(value);
    if (/^mr\.?$/i.test(text)) return 'Men';
    if (/^ms\.?$/i.test(text)) return 'Women';
    if (/^men$/i.test(text)) return 'Men';
    if (/^women$/i.test(text)) return 'Women';
    return '';
  }

  function titleGender(form) {
    var select = document.getElementById('224821');
    if (!select && form && form.querySelector) {
      select = form.querySelector('select[name="title"], select[data-cf-column-key="title"]');
    }
    return genderFromTitle(select && select.value);
  }

  function heliumSignupValues(form) {
    var phone = fieldById('500663');
    return {
      email: fieldById('345933'),
      first_name: fieldById('797347'),
      last_name: fieldById('874952'),
      phone: fullPhone(phone, form),
      gender: titleGender(form),
      birth_date: birthDate(fieldById('684699'))
    };
  }

  function onHeliumSignup(event) {
    if (!isSignupForm(event)) return;
    if (event && (event.type === 'cf:form_submission_failed' || event.type === 'cf:customer_save_failed')) return;
    var detail = (event && event.detail) || {};
    if (detail.errors && typeof detail.errors === 'object' && Object.keys(detail.errors).length) return;
    var form = heliumSignupForm(event);
    rememberCfSignup(detail.submissionData || detail.customer || {}, form, true);
    if (state.signupTimer) return;
    state.signupTimer = window.setTimeout(function () {
      if (!onRegisterPage() || state.signupTracked) return;
      var pending = false;
      var typed = {};
      try {
        pending = window.sessionStorage.getItem('exponea_signup') === '1';
        typed = JSON.parse(window.sessionStorage.getItem('exponea_auth_fields') || '{}');
      } catch (error) {}
      if (!pending || !typed.email) return;
      state.signupTracked = true;
      try {
        window.sessionStorage.setItem('exponea_signup_account', typed.email);
        window.sessionStorage.removeItem('exponea_signup');
        window.sessionStorage.removeItem('exponea_login');
      } catch (error) {}
      if (window.exponea && typeof window.exponea.identify === 'function') {
        window.exponea.identify({ email_id: typed.email });
      }
      trackSignup({
        email: typed.email,
        first_name: typed.first_name,
        last_name: typed.last_name,
        phone: typed.phone,
        gender: typed.gender,
        birth_date: typed.birth_date
      }, typed);
    }, 8000);
  }

  function recommendationProduct(card) {
    if (!card) return null;
    return defined({
      product_id: card.dataset.recoItemId,
      sku_id: card.dataset.recoSku,
      title: card.dataset.recoTitle,
      brand: card.dataset.recoBrand,
      price: card.dataset.recoPrice ? Number(card.dataset.recoPrice) : undefined,
      original_price: card.dataset.recoOriginal ? Number(card.dataset.recoOriginal) : undefined,
      position: card.dataset.recoPosition ? Number(card.dataset.recoPosition) : undefined
    });
  }

  function recommendationProducts(campaignId) {
    var products = [];
    var seen = {};
    Array.prototype.forEach.call(document.querySelectorAll('bloomreach-products'), function (widget) {
      if (widget.dataset.campaignId !== campaignId) return;
      Array.prototype.forEach.call(widget.querySelectorAll('li[data-reco-position]'), function (card) {
        var product = recommendationProduct(card);
        if (!product) return;
        var key = (product.product_id || '') + ':' + (product.position || '');
        if (seen[key]) return;
        seen[key] = true;
        products.push(product);
      });
    });
    return products;
  }

  function trackRecommendationShow(campaignId) {
    if (!campaignId || state.recoSent[campaignId]) return;
    var products = recommendationProducts(campaignId);
    if (!products.length) return;
    state.recoSent[campaignId] = true;
    var widget = null;
    Array.prototype.some.call(document.querySelectorAll('bloomreach-products'), function (node) {
      if (node.dataset.campaignId !== campaignId) return false;
      widget = node;
      return true;
    });
    var ids = [];
    var titles = [];
    var skus = [];
    var positions = [];
    products.forEach(function (product) {
      if (product.product_id) ids.push(product.product_id);
      if (product.sku_id) skus.push(product.sku_id);
      if (product.title) titles.push(product.title);
      if (product.position != null) positions.push(product.position);
    });
    track('recommendation', {
      action: 'show',
      recommendation_id: campaignId,
      recommendation_name: widget && widget.dataset.recoName,
      recommendation_type: widget && widget.dataset.strategy,
      placement: (widget && widget.dataset.placement) || pageType(),
      page_type: pageType(),
      widget_instance_id: widget && widget.id,
      products: products,
      product_ids: ids,
      sku_ids: skus,
      titles: titles,
      positions: positions
    });
  }

  function scheduleRecommendationShow(widget) {
    var campaignId = widget && widget.dataset.campaignId;
    if (!campaignId || state.recoSent[campaignId]) return;
    window.clearTimeout(state.recoTimers[campaignId]);
    state.recoTimers[campaignId] = window.setTimeout(function () {
      trackRecommendationShow(campaignId);
    }, 2000);
  }

  function trackRecommendation(action, widget, card) {
    if (!widget || action !== 'click') return;
    var line = recommendationProduct(card) || {};
    track('recommendation', Object.assign({
      action: 'click',
      recommendation_id: widget.dataset.campaignId,
      recommendation_name: widget.dataset.recoName,
      recommendation_type: widget.dataset.strategy,
      placement: widget.dataset.placement || pageType(),
      page_type: pageType(),
      widget_instance_id: widget.id
    }, line));
  }

  function clearWishlistPending(copy) {
    if (state.pending && state.pending.button_type === 'Wishlist' && state.pending.button_copy === copy) state.pending = null;
  }

  function wishlistPageRemoveControl(event) {
    var nodes = wishlistPath(event);
    var index;
    var node;
    var found;
    for (index = 0; index < nodes.length; index += 1) {
      node = nodes[index];
      if (!node || node.nodeType !== 1) continue;
      if (node.matches) {
        try {
          if (node.matches('.single_remove_product, .remove_wishlist_product, .wishlist-remove, [class*="single_remove"], [class*="remove_wishlist"]')) return node;
        } catch (error) {}
      }
      if (node.closest) {
        try {
          found = node.closest('.single_remove_product, .remove_wishlist_product, .wishlist-remove, [class*="single_remove"], [class*="remove_wishlist"]');
        } catch (error) {
          found = null;
        }
        if (found && !isWishlistButton(found)) return found;
      }
    }
    return null;
  }

  function detailsFromWishlistCard(control) {
    if (!control || !control.closest) return null;
    var card = control.closest('.wishlist-product-card, .wishlist-item, [class*="wishlist-product"], li, article') || control.parentElement;
    if (!card) return null;
    var atc = card.querySelector
      ? card.querySelector('[data-variantid], [data-variant-id], [data-variant], .wishlist-atc-event, .add-to-cart-btn, .wishlist_product_add_to_cart_to_pdp_page')
      : null;
    var heart = card.querySelector
      ? card.querySelector('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]')
      : null;
    var attrSource = heart || atc || control || card;
    var productId = String(
      (card.dataset && (card.dataset.productId || card.dataset.product || card.dataset.id)) ||
      (control.getAttribute && (control.getAttribute('data-product') || control.getAttribute('data-product-id') || control.getAttribute('data-proid'))) ||
      (atc && atc.getAttribute && (atc.getAttribute('data-product') || atc.getAttribute('data-product-id'))) ||
      (heart && heart.getAttribute && heart.getAttribute('data-product')) ||
      ''
    );
    var variantId = String(
      (card.dataset && (card.dataset.variantId || card.dataset.variant || card.dataset.objectId)) ||
      (control.getAttribute && (control.getAttribute('data-variantid') || control.getAttribute('data-variant-id') || control.getAttribute('data-variant'))) ||
      (atc && atc.getAttribute && (atc.getAttribute('data-variantid') || atc.getAttribute('data-variant-id') || atc.getAttribute('data-variant') || atc.getAttribute('data-object-id'))) ||
      (heart && heart.getAttribute && heart.getAttribute('data-variant')) ||
      ''
    );
    var handle = String(
      (card.dataset && (card.dataset.productHandle || card.dataset.handle)) ||
      (heart && heart.getAttribute && heart.getAttribute('data-handle')) ||
      (atc && atc.getAttribute && (atc.getAttribute('data-handle') || atc.getAttribute('data-product-handle'))) ||
      productHandle(card) ||
      ''
    );
    var title = String(
      (control.getAttribute && control.getAttribute('data-protitle')) ||
      (heart && heart.getAttribute && heart.getAttribute('data-product-name')) ||
      (atc && atc.getAttribute && atc.getAttribute('data-product-name')) ||
      ((card.querySelector && card.querySelector('.wishlist-product-title')) || {}).textContent ||
      ''
    ).replace(/\s+/g, ' ').trim();
    var barcode = String(
      (atc && atc.getAttribute && atc.getAttribute('data-barcode')) ||
      (heart && heart.getAttribute && heart.getAttribute('data-barcode')) ||
      (card.dataset && card.dataset.barcode) ||
      ''
    );
    var sku = String(
      (atc && atc.getAttribute && atc.getAttribute('data-sku')) ||
      (heart && heart.getAttribute && heart.getAttribute('data-sku')) ||
      (card.dataset && card.dataset.sku) ||
      ''
    );
    var vendor = String(
      (heart && heart.getAttribute && heart.getAttribute('data-vendor')) ||
      (atc && atc.getAttribute && atc.getAttribute('data-vendor')) ||
      (card.dataset && card.dataset.vendor) ||
      ''
    );
    var productType = String(
      (heart && heart.getAttribute && heart.getAttribute('data-product-type')) ||
      (atc && atc.getAttribute && atc.getAttribute('data-product-type')) ||
      (card.dataset && (card.dataset.productType || card.dataset.type)) ||
      ''
    );
    var color = String(
      (heart && heart.getAttribute && heart.getAttribute('data-color')) ||
      (atc && atc.getAttribute && atc.getAttribute('data-color')) ||
      (card.dataset && card.dataset.color) ||
      ''
    );
    var size = String(
      (heart && heart.getAttribute && heart.getAttribute('data-size')) ||
      (atc && atc.getAttribute && atc.getAttribute('data-size')) ||
      (card.dataset && card.dataset.size) ||
      ''
    );
    var listedPrice = Number(
      (attrSource && attrSource.getAttribute && (attrSource.getAttribute('data-price') || attrSource.getAttribute('data-product-price'))) ||
      (card.dataset && card.dataset.price) ||
      0
    );
    var listedCompare = Number(
      (attrSource && attrSource.getAttribute && attrSource.getAttribute('data-compare-at-price')) ||
      (card.dataset && card.dataset.compareAtPrice) ||
      0
    );
    if (!productId && !variantId && !handle) return null;
    return {
      productId: productId,
      variantId: variantId,
      handle: handle,
      title: title,
      barcode: barcode,
      sku: sku,
      vendor: vendor,
      productType: productType,
      color: color,
      size: size,
      listedPrice: listedPrice,
      listedCompare: listedCompare,
      card: card,
      heart: heart,
      atc: atc
    };
  }

  function trackWishlistPageRemove(control) {
    var details = detailsFromWishlistCard(control);
    if (!details) return;
    beginWishlistGesture(details.productId, details.variantId, 'remove');
    setPendingWishlistUi({
      action: 'remove',
      productId: details.productId,
      variantId: details.variantId,
      at: Date.now()
    });
    var source = details.heart || details.atc || control;
    lastWishlistButton = details.heart || lastWishlistButton;
    try {
      if (source && source.setAttribute) source.setAttribute('data-exponea-wl-click', String(Date.now()));
    } catch (error) {}
    var product = productFromPage(details.productId, details.handle) || {
      id: details.productId,
      title: details.title,
      handle: details.handle,
      vendor: details.vendor || '',
      type: details.productType || '',
      color: details.color || '',
      size: details.size || '',
      options: [],
      variants: []
    };
    if (!product.title && details.title) product.title = details.title;
    if (!product.handle && details.handle) product.handle = details.handle;
    if (!product.vendor && details.vendor) product.vendor = details.vendor;
    if (!product.type && details.productType) product.type = details.productType;
    if (!product.color && details.color) product.color = details.color;
    if (!product.size && details.size) product.size = details.size;
    if (details.heart) {
      var helium = heliumFromElement(details.heart);
      if (helium) product.categories = helium;
      applyWishlistDetails(product, details.heart);
    } else if (details.atc) {
      applyWishlistDetails(product, details.atc);
    } else if (details.card) {
      applyWishlistDetails(product, details.card);
    }
    var variant = wishlistVariant(product, details.variantId);
    if (!variant.id) variant.id = details.variantId;
    if (!variant.sku) variant.sku = details.sku;
    if (!variant.barcode) variant.barcode = details.barcode;
    if (!variant.price && details.listedPrice) variant.price = Math.round(details.listedPrice * 100);
    if (!variant.compare_at_price && details.listedCompare) variant.compare_at_price = Math.round(details.listedCompare * 100);
    applyButtonStock(variant, details.heart || details.atc || details.card);
    if (details.heart && details.heart.getAttribute) {
      if (!variant.barcode) variant.barcode = details.heart.getAttribute('data-barcode') || '';
      if (!variant.sku) variant.sku = details.heart.getAttribute('data-sku') || '';
      if (!variant.price) {
        var listedPrice = Number(details.heart.getAttribute('data-price'));
        if (listedPrice) variant.price = Math.round(listedPrice * 100);
      }
      if (!variant.compare_at_price) {
        var listedCompare = Number(details.heart.getAttribute('data-compare-at-price'));
        if (listedCompare) variant.compare_at_price = Math.round(listedCompare * 100);
      }
    }
    try {
      trackWishlistProduct(product, variant, 'remove', /wishlist/i.test(window.location.pathname + window.location.search) ? 'Wishlist' : buttonType());
    } catch (error) {
      track('wishlist', withCategoryIdPrefix(withStock(Object.assign({
        action: 'remove',
        shopify_parent_id: String(details.productId || ''),
        shopify_variant_id: String(details.variantId || ''),
        product_id: details.barcode || undefined,
        variant_id: details.sku || undefined,
        sku_id: details.sku || undefined,
        title: details.title || '',
        brand: details.vendor || undefined,
        color: details.color || undefined,
        size: details.size || undefined,
        button_copy: 'Remove from wishlist',
        button_type: 'Wishlist',
        page_type: wishlistPageType(),
        total_quantity: 1
      }, restoreWishlistLineSnapshot({}, product, variant)), variant)));
    }
  }

  function wishlistMoveButton(event) {
    if (wishlistButtonFromEvent(event)) return null;
    var nodes = wishlistPath(event);
    var index;
    var node;
    var found;
    for (index = 0; index < nodes.length; index += 1) {
      node = nodes[index];
      if (!node || node.nodeType !== 1) continue;
      if (node.matches) {
        try {
          if (node.matches('.wishlist-atc-event')) return node;
        } catch (error) {}
      }
      if (node.closest) {
        try { found = node.closest('.wishlist-atc-event'); } catch (error) { found = null; }
        if (found) return found;
      }
    }
    var onWishlistPage = /wishlist/i.test(window.location.pathname + ' ' + window.location.search);
    for (index = 0; index < nodes.length; index += 1) {
      node = nodes[index];
      if (!node || node.nodeType !== 1) continue;
      var marker = classText(node) + ' ' + String(node.id || '');
      var variantAttr = node.getAttribute && (node.getAttribute('data-variantid') || node.getAttribute('data-variant-id'));
      if (variantAttr && /wishlist|move-to-cart|movetocart/i.test(marker)) {
        if (isWishlistButton(node)) continue;
        return node;
      }
      if (!onWishlistPage) continue;
      var ownLabel = labelOf(node);
      if (ownLabel.length > 0 && ownLabel.length < 40 && /move to cart|move to bag|add to cart|add to bag/i.test(ownLabel)) return node;
      if (!node.closest) continue;
      var control = null;
      try { control = node.closest('button, a, [role="button"]'); } catch (error) {}
      if (!control) continue;
      if (/move to cart|move to bag|add to cart|add to bag/i.test(labelOf(control))) return control;
    }
    return null;
  }

  function loadCatalogProduct(handle) {
    if (!handle) return Promise.reject();
    if (!loadCatalogProduct.cache) loadCatalogProduct.cache = {};
    if (!loadCatalogProduct.cache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      loadCatalogProduct.cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response || !response.ok) throw new Error('catalog');
          return response.text();
        })
        .then(function (html) {
          var match = String(html || '').match(/<script[^>]*class="exponea-product"[^>]*>([\s\S]*?)<\/script>/i);
          if (!match) throw new Error('catalog');
          return JSON.parse(match[1]);
        })
        .catch(function (error) {
          // Do not cache failures — a later attempt may succeed.
          try { delete loadCatalogProduct.cache[handle]; } catch (err) {}
          throw error;
        });
    }
    return loadCatalogProduct.cache[handle];
  }

  function trackWishlistMoveToCart(button) {
    var copy = labelOf(button) || 'Move to Cart';
    var handle = productHandle(button);
    var variantId = String((button.getAttribute && (button.getAttribute('data-variantid') || button.getAttribute('data-variant-id') || button.getAttribute('data-variant'))) || '');
    var helium = heliumFromElement(button);
    state.pending = { action: 'add', button_type: 'Wishlist', button_copy: copy };
    // Suppress the cart-hook schedule while this path owns the cart_update emit.
    state.wishlistCartMoveUntil = Date.now() + 12000;
    state.meta = null;
    state.pendingCart = null;
    window.clearTimeout(state.timer);
    var baseline = state.cart;
    var baselineSignature = cartSignature(baseline);
    var baselineCount = baseline ? baseline.item_count : null;
    var settled = false;
    var attempts = 0;
    function emit(cart) {
      if (settled || !cart) return;
      var signature = cartSignature(cart);
      if (baselineCount == null) {
        baseline = cart;
        baselineSignature = signature;
        baselineCount = cart.item_count;
        state.cart = cart;
        return;
      }
      if (cart.item_count === baselineCount && signature === baselineSignature) return;
      settled = true;
      window.clearInterval(timer);
      clearWishlistPending(copy);
      var added = changedItem(baseline, cart, 'add');
      if (added && variantId && String(added.id) !== variantId) {
        var chosen = (cart.items || []).filter(function (item) {
          return String(item.id) === variantId && !isChildProps(item.properties);
        })[0];
        if (chosen) added = chosen;
      }
      function applyCatalogProduct(product) {
        if (!added || !product) return;
        var match = (product.variants || []).find(function (entry) { return String(entry.id) === variantId; }) || (product.variants || [])[0];
        if (!added.vendor && product.vendor) added.vendor = product.vendor;
        if (!added.product_type && product.type) added.product_type = product.type;
        if ((!added.tags || !added.tags.length) && product.tags) added.tags = product.tags;
        if (!added.color && product.color) added.color = product.color;
        added.categories = helium || product.categories || added.categories;
        if (match) {
          if (!added.barcode && match.barcode) added.barcode = match.barcode;
          if (!added.sku && match.sku) added.sku = match.sku;
          if (match.inventory != null) added.inventory = match.inventory;
          if (!added.original_price && match.compare_at_price) added.original_price = match.compare_at_price;
          if ((!added.options_with_values || !added.options_with_values.length) && product.options) {
            added.options_with_values = product.options.map(function (name, index) {
              return { name: name, value: match['option' + (index + 1)] || '' };
            });
          }
        }
        rememberItem(added);
        applyCatalog(added);
        if (helium || product.categories) added.categories = helium || product.categories;
      }
      function send() {
        state.cart = baseline;
        state.wishlistCartMoveUntil = 0;
        state.meta = null;
        state.pendingCart = null;
        trackCart(cart, { action: 'add', button_type: 'Wishlist', button_copy: copy, changed: true });
      }
      if (added && helium) added.categories = helium;
      var catalog = handle ? loadCatalogProduct(handle) : Promise.reject();
      catalog.then(function (product) {
        applyCatalogProduct(product);
        send();
      }).catch(function () {
        if (!handle) {
          send();
          return;
        }
        loadProduct(handle).then(function (product) {
          applyCatalogProduct(product);
          send();
        }).catch(send);
      });
    }
    if (baselineCount == null) fetchCart().then(emit).catch(function () {});
    var timer = window.setInterval(function () {
      attempts += 1;
      if (attempts > 25) {
        window.clearInterval(timer);
        state.wishlistCartMoveUntil = 0;
        clearWishlistPending(copy);
        if (state.meta || state.pendingCart) scheduleCart(state.meta || { action: 'add', button_type: 'Wishlist', button_copy: copy });
        return;
      }
      fetchCart().then(emit).catch(function () {});
    }, 400);
  }

  function wishlistButtonFromEvent(event) {
    var nodes = wishlistPath(event);
    var index;
    var node;
    var fallback = null;
    for (index = 0; index < nodes.length; index += 1) {
      node = nodes[index];
      if (!isWishlistButton(node)) continue;
      if (node.getAttribute && (node.getAttribute('data-product') || node.getAttribute('data-variant') || node.getAttribute('data-handle'))) return node;
      fallback = node;
    }
    if (fallback && page.page_type === 'product') return fallback;
    return null;
  }

  function watchWishlistAdds() {
    if (watchWishlistAdds.started || !window.MutationObserver) return;
    watchWishlistAdds.started = true;
    var seen = new WeakMap();
    function remember(button) {
      if (!button || seen.has(button)) return;
      seen.set(button, button.getAttribute('data-wl-active'));
    }
    Array.prototype.forEach.call(document.querySelectorAll('#mswishlistbutton, .mswishlistbutton, [id^="mswishlistbutton"]'), remember);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'data-wl-active') return;
        var button = mutation.target;
        if (!isWishlistButton(button)) return;
        var next = button.getAttribute('data-wl-active');
        if (button.getAttribute('data-wl-pending') === '1') return;
        var previous = seen.has(button) ? seen.get(button) : null;
        seen.set(button, next);
        var clickedAt = Number(button.getAttribute('data-exponea-wl-click') || 0);
        if (!clickedAt || Date.now() - clickedAt > 5000) return;
        lastWishlistButton = button;
        var productId = button.getAttribute('data-product') || '';
        var variantId = button.getAttribute('data-variant') || '';
        var action = '';
        if (previous === '1' && next !== '1') action = 'remove';
        else if (next === '1' && previous !== '1') action = 'add';
        else return;
        // Stick to the click intent; ignore attribute flicker that flips the opposite way.
        if (!wishlistGestureAllows(productId, variantId, action)) return;
        if (recentWishlistDecision(productId) === action) return;
        emitWishlist(button, action, productId, variantId);
      });
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-wl-active'],
      subtree: true
    });
  }

  function onClick(event) {
    var heart = wishlistButtonFromEvent(event);
    if (heart) {
      lastWishlistButton = heart;
      // Heart toggles must not inherit a stale wishlist-page remove hint.
      pendingWishlistUi = null;
      var intended = wishlistMarked(heart) ? 'remove' : 'add';
      beginWishlistGesture(
        heart.getAttribute('data-product') || '',
        heart.getAttribute('data-variant') || '',
        intended
      );
      try { heart.setAttribute('data-exponea-wl-click', String(Date.now())); } catch (error) {}
      return;
    }

    var wishlistRemove = wishlistPageRemoveControl(event);
    if (wishlistRemove) {
      trackWishlistPageRemove(wishlistRemove);
      return;
    }

    var wishlistAtc = wishlistMoveButton(event);
    if (wishlistAtc) {
      trackWishlistMoveToCart(wishlistAtc);
      return;
    }

    var target = event.target;
    if (!target || !target.closest) {
      var walk = target;
      while (walk && walk !== document) {
        if (walk.nodeType === 1 && isWishlistButton(walk) && walk.getAttribute && (walk.getAttribute('data-product') || walk.getAttribute('data-variant') || walk.getAttribute('data-handle'))) {
          lastWishlistButton = walk;
          try { walk.setAttribute('data-exponea-wl-click', String(Date.now())); } catch (error) {}
          return;
        }
        walk = walk.parentNode || walk.host || null;
      }
      return;
    }

    if (!event.isTrusted && state.pending) return;

    var sticky = target.closest('.sticky-atc__submit');
    var submit = target.closest('form[data-type="add-to-cart-form"] [type="submit"]');
    var popup = target.closest('#addtocart_popup_button');
    var listing = target.closest('.ais-hit--cart-button_custom');
    var remove = target.closest('cart-remove-button');
    var cartRoot = target.closest('cart-items, cart-drawer-items');
    var quantity = cartRoot && target.closest('.quantity__button');
    var moveWishlist = target.closest('cart-wishlist-button');

    if (sticky || submit) {
      var button = sticky || submit;
      state.pending = {
        action: 'add',
        button_type: sticky ? 'Add to bag overlay' : 'PDP',
        button_copy: labelOf(button) || 'Add to cart'
      };
      return;
    }
    if (popup || listing) {
      var addButton = popup || listing;
      state.pending = {
        action: 'add',
        button: addButton,
        button_type: page.page_type === 'search' ? 'Search' : 'PLP',
        button_copy: labelOf(addButton) || 'Add to cart'
      };
      rememberAddedDetails(addButton.getAttribute('data-object-id') || addButton.getAttribute('data-variant'), cartSourceFromButton(addButton));
      return;
    }
    if (remove) {
      state.pending = { action: 'remove', button_type: cartSurface(), button_copy: 'remove' };
      return;
    }
    if (quantity) {
      state.pending = {
        action: 'update',
        button_type: cartSurface(),
        button_copy: quantity.getAttribute('name') === 'minus' ? '-' : '+'
      };
      return;
    }
    if (moveWishlist) {
      var movedVariantId = String(moveWishlist.dataset.variantId || '');
      var movedItem = state.cart && (state.cart.items || []).find(function (item) {
        return String(item.id) === movedVariantId;
      });
      if (movedItem) pendingWishlistMove = { variantId: movedVariantId, item: movedItem };
      return;
    }
    var productLink = target.closest('bloomreach-products a[href*="/products/"]');
    if (productLink && !target.closest('button, .mswishlistbutton, .wishlistDiv, cart-wishlist-button, wishlist-button-collection, wishlist-button-product, [type="submit"]')) {
      trackRecommendation('click', productLink.closest('bloomreach-products'), productLink.closest('li'));
      return;
    }
    var wishlist = null;
    var nodes = wishlistPath(event);
    var nodeIndex;
    for (nodeIndex = 0; nodeIndex < nodes.length && !wishlist; nodeIndex += 1) {
      var clickNode = nodes[nodeIndex];
      if (!clickNode || clickNode.nodeType !== 1 || !clickNode.closest) continue;
      wishlist = clickNode.closest('.mswishlistbutton, [id^="mswishlistbutton"], wishlist-button-collection, wishlist-button-product, wishlist-button');
      if (!wishlist && clickNode.closest('.wishlistDiv')) wishlist = clickNode.closest('.wishlistDiv').closest('.mswishlistbutton, [id^="mswishlistbutton"]') || clickNode.closest('.wishlistDiv');
    }
    if (!wishlist || !wishlist.getAttribute || (!wishlist.getAttribute('data-product') && !wishlist.getAttribute('data-variant') && !wishlist.getAttribute('data-handle'))) return;
    lastWishlistButton = wishlist;
    try { wishlist.setAttribute('data-exponea-wl-click', String(Date.now())); } catch (error) {}
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var found = productFromForm(form);
    if (found) {
      var payload = linePayload(found.product, found.variant);
      ensureCategoryPath(payload);
      Object.assign(payload, selectionFlags({ usePage: true, scope: form || document }));
      writeLineInput(form, found.product, found.variant);
      var written = form.querySelector('.exponea-line-json');
      if (written) {
        try {
          var current = JSON.parse(written.value);
          if (payload.categories_path) current.categories_path = payload.categories_path;
          if (!current.product_id && payload.product_id) current.product_id = payload.product_id;
          if (!current.color && payload.color) current.color = payload.color;
          if ((!current.tags || !current.tags.length) && payload.tags) current.tags = payload.tags;
          current.engraving = !!payload.engraving;
          current.gift_wrapping = !!payload.gift_wrapping;
          written.value = JSON.stringify(current);
          payload = current;
        } catch (error) {}
      }
      rememberAddedDetails(found.variant.id, Object.assign({ handle: found.product.handle || '' }, payload));
      return;
    }
    var card = form.closest ? form.closest('.card-wrapper, .card, li, .product-card-wrapper') : null;
    var heart = card && card.querySelector('.mswishlistbutton, [id^="mswishlistbutton"]');
    var variantInput = form.querySelector('[name="id"]');
    var details = cartSourceFromButton(heart || form);
    if (!details || !variantInput || !variantInput.value) return;
    details.shopify_variant_id = String(variantInput.value);
    ensureCategoryPath(details);
    writeBloomInput(form, defined(details));
    rememberAddedDetails(variantInput.value, details);
  }

  function initCheckout(data) {
    if (!data) return;
    page = {
      store: data.store || STORE,
      domain: data.domain || '',
      language: data.language || '',
      currency: data.currency || '',
      tax_percentage: data.tax_percentage || 0,
      page_type: 'checkout',
      customer: data.customer || null
    };
    var step = (window.Shopify && window.Shopify.Checkout && (window.Shopify.Checkout.step || window.Shopify.Checkout.page)) || '';
    var stepNumber = { contact_information: 1, shipping_method: 2, payment_method: 3, thank_you: 4, checkout_one_thank_you: 4 }[step] || '';
    if (!stepNumber && (data.purchase || step === 'thank_you')) stepNumber = 4;
    var total = money(data.total_price);
    var checkoutProps = Object.assign(
      {
        step_title: step || (data.purchase ? 'thank_you' : ''),
        total_price: total,
        total_price_local_currency: total,
        currency: data.currency || currency(),
        total_quantity: data.total_quantity || 0
      },
      taxFields(total)
    );
    if (stepNumber) checkoutProps.step_number = stepNumber;
    if (data.shipping_city) checkoutProps.shipping_city = data.shipping_city;
    if (data.shipping_country) checkoutProps.shipping_country = data.shipping_country;
    if (data.shipping_method) checkoutProps.shipping_type = data.shipping_method;
    if (data.shipping_price) checkoutProps.shipping_cost = money(data.shipping_price);
    if (data.voucher_code) {
      checkoutProps.voucher_code = data.voucher_code;
      checkoutProps.discount_code = data.voucher_code;
      checkoutProps.voucher_percentage = data.voucher_percentage || '';
      checkoutProps.voucher_value = money(data.voucher_value);
    }
    if (data.payment_type) checkoutProps.payment_type = data.payment_type;
    if (step || data.purchase) track('checkout', checkoutProps);

    if (data.customer && data.customer.email && window.exponea && typeof window.exponea.update === 'function') {
      window.exponea.update({
        email_id: data.customer.email,
        shopify_id: data.customer.id,
        first_name: data.customer.first_name || '',
        last_name: data.customer.last_name || '',
        phone: data.customer.phone || '',
        domain: data.domain,
        language: data.language
      });
    }

    if (!data.purchase) return;
    track(
      'purchase',
      Object.assign(
        {
          purchase_status: 'success',
          total_price: total,
          language: data.language,
          purchase_id: data.order_id ? String(data.order_id) : '',
          _name: data.order_name || '',
          shipping_cost: money(data.shipping_price),
          payment_type: data.payment_type || '',
          voucher_code: data.voucher_code || '',
          discount_code: data.voucher_code || '',
          voucher_percentage: data.voucher_percentage || '',
          voucher_value: money(data.voucher_value),
          tags: data.order_tags || []
        },
        taxFields(total)
      )
    );
    (data.line_items || []).forEach(function (line) {
      line.bloom = parseBloom(line.bloom) || {};
      var lineTotal = money(line.line_price);
      track(
        'purchase_item',
        Object.assign(
          {
            purchase_status: 'success',
            product_id: line.product_id,
            variant_id: line.variant_id,
            title: line.title,
            brand: line.vendor || '',
            price: money(line.price),
            total_price: lineTotal,
            price_local_currency: lineTotal,
            quantity: String(line.quantity),
            location: window.location.href,
            language: data.language,
            payment_type: data.payment_type || '',
            voucher_code: data.voucher_code || '',
            discount_code: data.voucher_code || ''
          },
          taxFields(lineTotal),
          line.bloom || {}
        )
      );
    });
  }

  installCartHook();
  watchWishlistAdds();
  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);
  function trackConsentChoice(choice, fields) {
    if (!window.exponea || typeof window.exponea.track !== 'function' || !choice) return;
    var email = (fields && fields.email) || (page.customer && page.customer.email) || '';
    var phone = fields && fields.phone;
    var identity = email || phone || '';
    var identityType = email ? 'email_id' : (phone ? 'phone_id' : '');
    track('consent', {
      action: choice.accepted ? 'accept' : 'reject',
      browser: browserName(),
      category: choice.category,
      device: consentDevice(),
      identification: identity,
      identification_type: identityType,
      language: page.language || '',
      location: choice.location || window.location.href,
      message: choice.message,
      os: consentOs(),
      placement: 'signup_form',
      domain: page.domain
    });
  }

  document.addEventListener('cf:form_submitted', function (event) {
    try { onHeliumSignup(event); } catch (error) {}
  }, true);

  document.addEventListener('cf:customer_saved', function (event) {
    try { onHeliumSignup(event); } catch (error) {}
  }, true);

  document.addEventListener('cf:ready', function () {
    watchCreateCustomer();
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
      if (!input || input.name !== 'id' || page.page_type !== 'product') return;
      trackViewItem();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;
    try {
      var kind = authKind(form);
      if (kind) rememberAuth(form, kind);
      if (form.action && /\/account\/addresses/.test(form.action)) window.sessionStorage.setItem('exponea_profile', '1');
    } catch (error) {}
  }, true);

  document.addEventListener('exponea:recommendations', function (event) {
    var widget = event.target;
    if (!widget || !widget.dataset) return;
    scheduleRecommendationShow(widget);
  });

  function seedKnownProducts() {
    var products = (page.collection && page.collection.products) || [];
    products.forEach(function (product) {
      if (!product || product.variant_id == null || !product.barcode) return;
      var id = String(product.variant_id);
      state.catalog[id] = Object.assign({}, state.catalog[id] || {}, { barcode: String(product.barcode) });
    });
  }

  if (document.getElementById('exponea-page')) {
    try {
      if (onLoginPage() && !(page.customer && page.customer.email)) {
        window.sessionStorage.removeItem('exponea_login');
        if (window.sessionStorage.getItem('exponea_signup') !== '1') window.sessionStorage.removeItem('exponea_auth_fields');
      }
    } catch (error) {}
    seedKnownProducts();
    state.cart = normalizeCart(page.cart) || state.cart;
    trackViewItem();
    trackSuccessfulLogin();
    trackSignupPage();
    whenCategoryReady(trackCategory);
    watchCategoryRefinements();
    watchSearch();
    watchHeaderSearch();
    watchLoginForm();
    watchCreateCustomer();
    syncCustomer();
  }

  function rememberAttribution() {
    try {
      function read(name) {
        var match = String(document.cookie || '').match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
      }
      function write(name, value) {
        document.cookie = name + '=' + encodeURIComponent(String(value).slice(0, 180)) + '; path=/; max-age=2592000; SameSite=Lax';
      }
      if (!read('exponea_landing')) {
        var path = window.location.pathname + window.location.search;
        if (path && path !== '/') write('exponea_landing', path);
      }
      if (!read('exponea_referrer') && document.referrer) {
        var host = new URL(document.referrer).hostname.replace(/^www\./, '');
        var here = window.location.hostname.replace(/^www\./, '');
        if (host && host !== here && host.indexOf('shopify.com') === -1) write('exponea_referrer', host);
      }
    } catch (error) {}
  }

  rememberAttribution();

  initCheckout(readJson('exponea-checkout'));
})();
